import React, { useState, useEffect } from 'react';
import Chart from 'react-apexcharts';
import './OperationsCenter.css';
import { callApi } from '../../ApiHelper/ApiHelper';
import { apiUrl } from '../../ApiHelper/ApiUrl';
import { RoutesLink } from '../../ApiHelper/RoutesLink';
import * as XLSX from 'xlsx';
import { toast } from 'react-toastify';
import SearchSiteSelect from '../../components/comman/SiteSearchSelect';

const OperationsCenter = () => {

  const openPaymentTicketDetail = (p) => {
    if (!p) return;
    const rawType = (p.type || '').toLowerCase();
    let type = 'general';
    if (rawType.includes('reimbursement')) {
      type = 'reimbursement';
    } else if (rawType.includes('po') || rawType.includes('againstpo') || p.purchaseOrderId || p.poId || p.purchaseId || p.purchaseNumber || p.purchaseOrder) {
      type = 'againstPo';
    }
    const id = p.id || p.ticketId || p.paymentTicketId;
    if (id) {
      const url = `${window.location.origin}${RoutesLink.payment_tickets_details}/${type}/${id}`;
      window.open(url, '_blank');
    }
  };

  // Zone Tab State
  const [activeZone, setActiveZone] = useState('overview'); // 'overview' | 'sites' | 'procurement' | 'pulse' | 'salary'
  const [salaryData, setSalaryData] = useState(null);

  // Drawer State
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedSiteDetails, setSelectedSiteDetails] = useState(null);
  const [siteRecentExpenses, setSiteRecentExpenses] = useState([]);
  const [siteDrilldownData, setSiteDrilldownData] = useState(null);

  // Vendor Drawer State
  const [vendorDrawerOpen, setVendorDrawerOpen] = useState(false);
  const [selectedVendorDetails, setSelectedVendorDetails] = useState(null);

  // Dashboard Analytics States
  const [executiveData, setExecutiveData] = useState(null);
  const [financialData, setFinancialData] = useState(null);
  const [sitesData, setSitesData] = useState([]);
  const [alerts, setAlerts] = useState([]);
  const [activities, setActivities] = useState([]);
  const [forecasts, setForecasts] = useState([]);
  const [vendorsData, setVendorsData] = useState([]);
  const [paymentsData, setPaymentsData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Pagination & Search for Sites
  const [sitePage, setSitePage] = useState(1);
  const [siteSearch, setSiteSearch] = useState("");
  const [siteStatusFilter, setSiteStatusFilter] = useState("all");

  // Pagination & Search for Vendors
  const [vendorSearch, setVendorSearch] = useState("");
  const [vendorPage, setVendorPage] = useState(1);

  // Work Orders States
  const [workOrdersData, setWorkOrdersData] = useState({ summary: {}, distribution: { categories: [], valued: [], invoiced: [], cleared: [] }, list: [] });
  const [workOrderSearch, setWorkOrderSearch] = useState("");
  const [workOrderPage, setWorkOrderPage] = useState(1);

  // Profit & Loss States
  const [profitLossData, setProfitLossData] = useState({ summary: {}, ledger: [], siteSummary: [], monthlySummary: [] });
  const [plSubTab, setPlSubTab] = useState("sites"); // 'sites' | 'months' | 'ledger'
  const [expandedSiteIds, setExpandedSiteIds] = useState([]);
  const [plSiteSearch, setPlSiteSearch] = useState("");
  const [plSitePage, setPlSitePage] = useState(1);
  const [plSiteLimit, setPlSiteLimit] = useState(10);
  const [profitLossSearch, setProfitLossSearch] = useState("");
  const [profitLossPage, setProfitLossPage] = useState(1);
  const [plMonthFilter, setPlMonthFilter] = useState("all");
  const [salaryMonthFilter, setSalaryMonthFilter] = useState("all");
  const [plTypeFilter, setPlTypeFilter] = useState("all");
  const [profitLossLimit, setProfitLossLimit] = useState(10);

  // GST Summary States
  const [gstSummaryData, setGstSummaryData] = useState({ summary: {}, rates: [] });
  const [gstDrawerOpen, setGstDrawerOpen] = useState(false);

  // Filters State
  const [companiesList, setCompaniesList] = useState([]);
  const [sitesList, setSitesList] = useState([]);

  const [filters, setFilters] = useState({
    financialYear: '2026-2027',
    companyId: '',
    siteId: '',
    startDate: '',
    endDate: ''
  });

  useEffect(() => {
    fetchFiltersData();
    fetchDashboardData();

    // Hover layout listeners for sidebar, header, and footer auto-hide
    const handleMouseMove = (e) => {
      if (window.innerWidth <= 991) return;

      const mainWrapper = document.querySelector('.main-wrapper');
      if (!mainWrapper) return;

      // Header trigger (top 15px)
      if (e.clientY < 15) {
        mainWrapper.classList.add('oc-header-show');
      } else if (e.clientY > 110) {
        const headerEl = document.querySelector('.header');
        if (headerEl && !headerEl.contains(e.target)) {
          mainWrapper.classList.remove('oc-header-show');
        }
      }

      // Sidebar trigger (left 15px)
      if (e.clientX < 15) {
        mainWrapper.classList.add('oc-sidebar-show');
      } else if (e.clientX > 260) {
        const sidebarEl = document.querySelector('.sidebar-wrapper');
        if (sidebarEl && !sidebarEl.contains(e.target)) {
          mainWrapper.classList.remove('oc-sidebar-show');
        }
      }

      // Footer trigger (bottom 15px)
      if (e.clientY > window.innerHeight - 15) {
        mainWrapper.classList.add('oc-footer-show');
      } else if (e.clientY < window.innerHeight - 100) {
        const footerEl = document.querySelector('.footer');
        if (footerEl && !footerEl.contains(e.target)) {
          mainWrapper.classList.remove('oc-footer-show');
        }
      }
    };

    const mainWrapper = document.querySelector('.main-wrapper');
    if (mainWrapper) {
      mainWrapper.classList.add('oc-layout-wrapper');
    }

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      if (mainWrapper) {
        mainWrapper.classList.remove('oc-layout-wrapper', 'oc-header-show', 'oc-sidebar-show', 'oc-footer-show');
      }
    };
  }, []);

  const fetchFiltersData = async () => {
    try {
      const compRes = await callApi(apiUrl.get_company, { method: "GET" });
      if (compRes?.status) setCompaniesList(compRes?.data?.company || []);
      const siteRes = await callApi(apiUrl.get_site, { method: "GET" });
      if (siteRes?.status) setSitesList(siteRes?.data?.site || []);
    } catch (error) {
      console.error("Error fetching filters data:", error);
    }
  };

  const fetchDashboardData = async () => {
    setLoading(true);
    try {
      const queryParams = new URLSearchParams();
      if (filters.financialYear) queryParams.append('financialYear', filters.financialYear);
      if (filters.companyId) queryParams.append('companyId', filters.companyId);
      if (filters.siteId) queryParams.append('siteId', filters.siteId);
      if (filters.startDate) queryParams.append('startDate', filters.startDate);
      if (filters.endDate) queryParams.append('endDate', filters.endDate);

      const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';

      const [
        executiveRes, financialRes, sitesRes, alertsRes, activityRes, forecastRes, vendorsRes, paymentsRes, workOrdersRes, profitLossRes, gstSummaryRes, salaryRes
      ] = await Promise.all([
        callApi(`${apiUrl.get_analytics_executive}${queryString}`, { method: "GET" }),
        callApi(`${apiUrl.get_analytics_financial}${queryString}`, { method: "GET" }),
        callApi(`${apiUrl.get_analytics_sites}${queryString}`, { method: "GET" }),
        callApi(`${apiUrl.get_analytics_alerts}${queryString}`, { method: "GET" }),
        callApi(`${apiUrl.get_analytics_activity}${queryString}`, { method: "GET" }),
        callApi(`${apiUrl.get_analytics_forecast}${queryString}`, { method: "GET" }),
        callApi(`${apiUrl.get_analytics_vendors}${queryString}`, { method: "GET" }),
        callApi(`${apiUrl.get_analytics_payments}${queryString}`, { method: "GET" }),
        callApi(`${apiUrl.get_analytics_workorders}${queryString}`, { method: "GET" }),
        callApi(`${apiUrl.get_analytics_profitloss}${queryString}`, { method: "GET" }),
        callApi(`${apiUrl.get_analytics_gstsummary}${queryString}`, { method: "GET" }),
        callApi(`${apiUrl.get_analytics_salary}${queryString}`, { method: "GET" })
      ]);

      if (executiveRes?.success) setExecutiveData(executiveRes.data);
      if (financialRes?.success) setFinancialData(financialRes.data);
      if (sitesRes?.success) setSitesData(sitesRes.data);
      if (alertsRes?.success) setAlerts(alertsRes.data);
      if (activityRes?.success) setActivities(activityRes.data);
      if (forecastRes?.success) setForecasts(forecastRes.data);
      if (vendorsRes?.success) setVendorsData(vendorsRes.data);
      if (paymentsRes?.success) setPaymentsData(paymentsRes.data);
      if (workOrdersRes?.success) setWorkOrdersData(workOrdersRes.data);
      if (profitLossRes?.success) setProfitLossData(profitLossRes.data);
      if (gstSummaryRes?.success) setGstSummaryData(gstSummaryRes.data);
      if (salaryRes?.success) setSalaryData(salaryRes.data);

    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setLoading(false);
    }
  };

  const openSiteDrawer = async (site) => {
    setSelectedSiteDetails(site);
    setDrawerOpen(true);
    setSiteRecentExpenses([]);
    setSiteDrilldownData(null);

    try {
      const [paymentsRes, drilldownRes] = await Promise.all([
        callApi(`${apiUrl.get_analytics_payments}?siteId=${site.id}&financialYear=${filters.financialYear}`, { method: "GET" }),
        callApi(`${apiUrl.get_analytics_drilldown}?siteId=${site.id}&financialYear=${filters.financialYear}`, { method: "GET" })
      ]);

      if (paymentsRes?.success) setSiteRecentExpenses(paymentsRes.data);
      if (drilldownRes?.success) setSiteDrilldownData(drilldownRes.data);
    } catch (e) {
      console.error("Error fetching site drilldown", e);
    }
  };

  const closeDrawer = () => {
    setDrawerOpen(false);
    setTimeout(() => {
      setSelectedSiteDetails(null);
      setSiteRecentExpenses([]);
      setSiteDrilldownData(null);
    }, 300);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => {
      const updated = { ...prev, [name]: value };
      if (name === 'companyId') {
        const selectedSite = sitesList.find(s => s.id === prev.siteId);
        if (selectedSite && value) {
          const sCompId = (selectedSite.companyId || selectedSite.Company?.id || "").toString().toLowerCase().trim();
          const newCompId = value.toString().toLowerCase().trim();
          if (sCompId !== newCompId) {
            updated.siteId = '';
          }
        }
      }
      return updated;
    });
  };

  // Currency Helper
  const formatChartCurrency = (value) => {
    if (!value && value !== 0) return '₹0';
    if (Math.abs(value) >= 10000000) return `₹${(value / 10000000).toFixed(1)}Cr`;
    if (Math.abs(value) >= 100000) return `₹${(value / 100000).toFixed(1)}L`;
    return `₹${Number(value).toLocaleString('en-IN')}`;
  };

  // ApexCharts Configurations
  const budgetUtilizationChart = {
    options: {
      chart: { type: 'radialBar', background: 'transparent' },
      plotOptions: {
        radialBar: {
          hollow: { size: '62%' },
          track: { background: '#f1f5f9' },
          dataLabels: {
            name: { show: true, fontSize: '13px', color: '#64748b', fontWeight: 600, offsetY: -8 },
            value: { fontSize: '26px', fontWeight: 800, formatter: val => val + "%", color: '#0f172a', offsetY: 6 }
          }
        }
      },
      colors: ['#2563eb'],
      labels: ['Health Rating']
    },
    series: [executiveData?.healthScore || 85]
  };

  const expenseDistributionChart = {
    options: {
      chart: { type: 'donut', background: 'transparent' },
      labels: financialData?.expenseDistribution?.labels || [],
      colors: ['#2563eb', '#10b981', '#f59e0b', '#8b5cf6', '#64748b', '#ec4899'],
      dataLabels: { enabled: false },
      plotOptions: { pie: { donut: { size: '75%' } } },
      legend: { position: 'bottom', fontSize: '12px', fontWeight: 500 },
      stroke: { show: true, width: 2, colors: ['#ffffff'] },
      tooltip: {
        y: { formatter: formatChartCurrency }
      }
    },
    series: financialData?.expenseDistribution?.series || []
  };

  const monthlySpendingChart = {
    options: {
      chart: { type: 'bar', toolbar: { show: false }, background: 'transparent' },
      colors: ['#2563eb'],
      plotOptions: { bar: { borderRadius: 6, columnWidth: '45%' } },
      dataLabels: { enabled: false },
      xaxis: {
        categories: financialData?.monthlySpending?.categories || [],
        axisBorder: { show: false },
        axisTicks: { show: false }
      },
      yaxis: { labels: { formatter: formatChartCurrency } },
      grid: { borderColor: 'rgba(226, 232, 240, 0.8)', strokeDashArray: 4 },
      tooltip: { y: { formatter: formatChartCurrency } }
    },
    series: [{ name: 'Actual Spends', data: financialData?.monthlySpending?.actual || [] }]
  };

  const budgetVsActualChart = {
    options: {
      chart: { type: 'bar', stacked: false, toolbar: { show: false }, background: 'transparent' },
      plotOptions: { bar: { horizontal: true, borderRadius: 5, barHeight: '55%' } },
      colors: ['#2563eb', '#10b981'],
      dataLabels: { enabled: false },
      xaxis: {
        categories: financialData?.expenseDistribution?.labels || [],
        labels: { formatter: formatChartCurrency }
      },
      legend: { position: 'top', horizontalAlign: 'right' },
      grid: { borderColor: 'rgba(226, 232, 240, 0.8)', strokeDashArray: 4 },
      tooltip: { y: { formatter: formatChartCurrency } }
    },
    series: [
      { name: 'Allocated Budget', data: financialData?.expenseDistribution?.series || [] },
      { name: 'Actual Spent', data: financialData?.expenseDistribution?.actuals || [] }
    ]
  };

  const budgetTrendChart = {
    options: {
      chart: { type: 'line', toolbar: { show: false }, background: 'transparent' },
      colors: ['#2563eb', '#94a3b8'],
      stroke: { curve: 'smooth', width: 3, dashArray: [0, 4] },
      xaxis: { categories: financialData?.monthlySpending?.categories || [] },
      yaxis: { labels: { formatter: formatChartCurrency } },
      grid: { borderColor: 'rgba(226, 232, 240, 0.8)', strokeDashArray: 4 },
      legend: { position: 'top', horizontalAlign: 'right' },
      tooltip: { y: { formatter: formatChartCurrency } }
    },
    series: [
      { name: 'Actual Spending', data: financialData?.monthlySpending?.actual || [] },
      { name: 'Budget Allocation', data: financialData?.monthlySpending?.budgeted || [] }
    ]
  };

  // Site Filtering logic
  const filteredSites = sitesData.filter(s => {
    const matchesSearch = s.name.toLowerCase().includes(siteSearch.toLowerCase());
    const matchesStatus = siteStatusFilter === 'all' ||
      (siteStatusFilter === 'normal' && s.status && s.status.toLowerCase() === 'on track') ||
      (s.status && s.status.toLowerCase() === siteStatusFilter.toLowerCase());
    return matchesSearch && matchesStatus;
  });

  const sitesPerPage = 8;
  const totalSitePages = Math.ceil(filteredSites.length / sitesPerPage) || 1;
  const currentSites = filteredSites.slice((sitePage - 1) * sitesPerPage, sitePage * sitesPerPage);

  // Vendor Filtering logic
  const filteredVendors = vendorsData.filter(v => {
    const term = vendorSearch.toLowerCase();
    return (v.name && v.name.toLowerCase().includes(term)) ||
      (v.firmName && v.firmName.toLowerCase().includes(term)) ||
      (v.city && v.city.toLowerCase().includes(term)) ||
      (v.state && v.state.toLowerCase().includes(term));
  });

  const vendorsPerPage = 6;
  const totalVendorPages = Math.ceil(filteredVendors.length / vendorsPerPage) || 1;
  const currentVendors = filteredVendors.slice((vendorPage - 1) * vendorsPerPage, vendorPage * vendorsPerPage);

  if (loading && !executiveData) {
    return (
      <div className="oc-container" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '80vh', gap: '16px' }}>
        <div style={{ width: '48px', height: '48px', borderRadius: '50%', border: '4px solid #eff6ff', borderTopColor: '#2563eb', animation: 'spin 1s linear infinite' }}></div>
        <h3 style={{ color: '#0f172a', fontWeight: 700 }}>Initializing Operations Intelligence Center...</h3>
        <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  const handleExportProfitLoss = (type = 'sites') => {
    try {
      const workbook = XLSX.utils.book_new();
      const monthsOrder = ['Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'];
      const monthNamesFull = {
        'Apr': 'April', 'May': 'May', 'Jun': 'June', 'Jul': 'July', 'Aug': 'August', 'Sep': 'September',
        'Oct': 'October', 'Nov': 'November', 'Dec': 'December', 'Jan': 'January', 'Feb': 'February', 'Mar': 'March'
      };

      // 1. Prepare Site-wise Data
      const headOfficeKey = 'headoffice';
      const siteMap = {};

      // Seed with master sites
      sitesList.forEach(s => {
        const sId = String(s.id);
        const cName = s.company ? s.company.name : (s.Company ? s.Company.name : 'N/A');
        siteMap[sId] = { siteName: s.name, companyName: cName, revenue: 0, salary: 0, po: 0, gen: 0, totalExp: 0 };
      });

      // Head office entry
      siteMap[headOfficeKey] = {
        siteName: '🏢 Head Office & Corporate Expenses (General)',
        companyName: 'Corporate / Unassigned',
        revenue: 0, salary: 0, po: 0, gen: 0, totalExp: 0
      };

      (profitLossData.ledger || []).forEach(item => {
        const targetKey = (item.siteId && siteMap[String(item.siteId)]) ? String(item.siteId) : headOfficeKey;
        const d = new Date(item.dateRaw || item.date);
        const monthsShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const itemMonth = item.date ? monthsShort[parseInt(item.date.split('-')[1], 10) - 1] : d.toLocaleString('en-US', { month: 'short' });
        if (plMonthFilter === 'all' || plMonthFilter === itemMonth) {
          siteMap[targetKey].revenue += item.credit || 0;
          siteMap[targetKey].totalExp += item.debit || 0;
          if (item.type === 'Salary') siteMap[targetKey].salary += item.debit;
          else if (item.type === 'PO') siteMap[targetKey].po += item.debit;
          else if (item.type === 'Payment') siteMap[targetKey].gen += item.debit;
        }
      });

      const siteRows = Object.values(siteMap).filter(s => {
        if (s.siteName.includes('Head Office') && s.revenue === 0 && s.totalExp === 0) return false;
        return true;
      }).map(s => {
        const net = s.revenue - s.totalExp;
        const margin = s.revenue > 0 ? ((net / s.revenue) * 100).toFixed(1) + '%' : '0%';
        return {
          "Site Name": s.siteName,
          "Company": s.companyName,
          "Month Period": plMonthFilter === 'all' ? `FY ${filters.financialYear}` : (monthNamesFull[plMonthFilter] || plMonthFilter),
          "Revenue (Invoiced ₹)": s.revenue,
          "Salary Expenses (₹)": s.salary,
          "PO Expenses (₹)": s.po,
          "General Expenses (₹)": s.gen,
          "Payment Expenses (₹)": s.po + s.gen,
          "Total Expenses (₹)": s.totalExp,
          "Net Profit / (Loss) (₹)": net,
          "Margin (%)": margin,
          "Status": net >= 0 ? "Profitable" : "In Deficit"
        };
      });

      // 2. Prepare Month-wise Data
      const monthRows = monthsOrder.map(m => {
        let mRev = 0, mSal = 0, mPo = 0, mGen = 0, mTotExp = 0;
        (profitLossData.ledger || []).forEach(item => {
          const d = new Date(item.dateRaw || item.date);
          const monthsShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
          const itemMonth = item.date ? monthsShort[parseInt(item.date.split('-')[1], 10) - 1] : d.toLocaleString('en-US', { month: 'short' });
          if (itemMonth === m) {
            mRev += item.credit || 0;
            mTotExp += item.debit || 0;
            if (item.type === 'Salary') mSal += item.debit;
            else if (item.type === 'PO') mPo += item.debit;
            else if (item.type === 'Payment') mGen += item.debit;
          }
        });
        const mNet = mRev - mTotExp;
        const mMargin = mRev > 0 ? ((mNet / mRev) * 100).toFixed(1) + '%' : '0%';
        return {
          "Month": monthNamesFull[m],
          "Revenue (Invoiced ₹)": mRev,
          "Salary Expenses (₹)": mSal,
          "PO Expenses (₹)": mPo,
          "General Expenses (₹)": mGen,
          "Payment Expenses (₹)": mPo + mGen,
          "Total Expenses (₹)": mTotExp,
          "Net Profit / (Loss) (₹)": mNet,
          "Margin (%)": mMargin,
          "Status": mNet >= 0 ? "Profitable" : "In Deficit"
        };
      });

      // 3. Prepare Ledger Data
      let filteredByMonth = profitLossData.ledger || [];
      if (plMonthFilter !== "all") {
        filteredByMonth = (profitLossData.ledger || []).filter(item => {
          if (!item.date) return false;
          const parts = item.date.split('-');
          const monthsShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
          const m = monthsShort[parseInt(parts[1], 10) - 1];
          return m === plMonthFilter;
        });
      }
      const filteredLedger = filteredByMonth.filter(item => {
        if (plTypeFilter !== "all" && item.type !== plTypeFilter) {
          return false;
        }
        const term = profitLossSearch.toLowerCase();
        return (item.reference && item.reference.toLowerCase().includes(term)) ||
          (item.party && item.party.toLowerCase().includes(term)) ||
          (item.siteName && item.siteName.toLowerCase().includes(term)) ||
          (item.type && item.type.toLowerCase().includes(term)) ||
          (item.status && item.status.toLowerCase().includes(term));
      });

      const ledgerRows = filteredLedger.map(item => ({
        "Date": item.displayDate || item.date,
        "Reference": item.reference,
        "Site / Party": item.siteName || item.party,
        "Type": item.type,
        "Debit (Out ₹)": item.debit > 0 ? item.debit : 0,
        "Credit (In ₹)": item.credit > 0 ? item.credit : 0,
        "Status": item.status || "Pending"
      }));

      const autofit = (ws, data) => {
        if (!data || data.length === 0) return;
        const maxLens = {};
        data.forEach(row => {
          Object.keys(row).forEach(key => {
            const val = String(row[key] || '');
            maxLens[key] = Math.max(maxLens[key] || key.length, val.length);
          });
        });
        ws["!cols"] = Object.keys(maxLens).map(key => ({ wch: Math.min(maxLens[key] + 4, 40) }));
      };

      if (type === 'sites') {
        const ws = XLSX.utils.json_to_sheet(siteRows);
        autofit(ws, siteRows);
        XLSX.utils.book_append_sheet(workbook, ws, "Site-wise P&L");
        XLSX.writeFile(workbook, `Site_Wise_PL_${plMonthFilter}_${filters.financialYear}.xlsx`);
      } else if (type === 'months') {
        const ws = XLSX.utils.json_to_sheet(monthRows);
        autofit(ws, monthRows);
        XLSX.utils.book_append_sheet(workbook, ws, "Month-wise Statement");
        XLSX.writeFile(workbook, `Monthly_PL_Statement_${filters.financialYear}.xlsx`);
      } else if (type === 'ledger') {
        const ws = XLSX.utils.json_to_sheet(ledgerRows);
        autofit(ws, ledgerRows);
        XLSX.utils.book_append_sheet(workbook, ws, "General Ledger");
        XLSX.writeFile(workbook, `General_Ledger_${plMonthFilter}_${filters.financialYear}.xlsx`);
      } else {
        const wsSites = XLSX.utils.json_to_sheet(siteRows);
        const wsMonths = XLSX.utils.json_to_sheet(monthRows);
        const wsLedger = XLSX.utils.json_to_sheet(ledgerRows);
        autofit(wsSites, siteRows);
        autofit(wsMonths, monthRows);
        autofit(wsLedger, ledgerRows);
        XLSX.utils.book_append_sheet(workbook, wsSites, "Site-wise P&L");
        XLSX.utils.book_append_sheet(workbook, wsMonths, "Month-wise Statement");
        XLSX.utils.book_append_sheet(workbook, wsLedger, "General Ledger");
        XLSX.writeFile(workbook, `Profit_Loss_Comprehensive_${filters.financialYear}.xlsx`);
      }

      toast.success("Excel report exported successfully");
    } catch (error) {
      console.error("Excel export error:", error);
      toast.error("Failed to export Excel report");
    }
  };

  const handleExportLedger = () => handleExportProfitLoss('ledger');

  return (
    <div className="oc-container">
      {/* Sticky Filter Bar */}
      <div className="oc-filter-bar">
        <div className="oc-filter-item">
          <label>Financial Year</label>
          <select name="financialYear" value={filters.financialYear} onChange={handleFilterChange}>
            <option value="2026-2027">2026-2027</option>
            <option value="2025-2026">2025-2026</option>
          </select>
        </div>
        <div className="oc-filter-item">
          <label>Company</label>
          <select name="companyId" value={filters.companyId} onChange={handleFilterChange}>
            <option value="">All Companies</option>
            {companiesList.map(c => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </select>
        </div>
        <div className="oc-filter-item" style={{ minWidth: '220px' }}>
          <label>O&M Site</label>
          <SearchSiteSelect
            placeholder="Search site..."
            options={[
              { value: "", label: "All Sites" },
              ...sitesList
                .filter(s => {
                  if (!filters.companyId) return true;
                  const sCompId = (s.companyId || s.Company?.id || "").toString().toLowerCase().trim();
                  const fCompId = filters.companyId.toString().toLowerCase().trim();
                  return sCompId === fCompId;
                })
                .map(s => ({ value: s.id, label: s.name }))
            ]}
            value={filters.siteId}
            onSelect={(selectedOpt) => {
              setFilters(prev => ({
                ...prev,
                siteId: selectedOpt?.value || ""
              }));
            }}
            showClearButton={true}
          />
        </div>
        <div className="oc-filter-item">
          <label>Start Date</label>
          <input type="date" name="startDate" value={filters.startDate} onChange={handleFilterChange} />
        </div>
        <div className="oc-filter-item">
          <label>End Date</label>
          <input type="date" name="endDate" value={filters.endDate} onChange={handleFilterChange} />
        </div>
        <button className="oc-btn-primary" onClick={fetchDashboardData} disabled={loading}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 2v6h-6"></path><path d="M3 12a9 9 0 0 1 15-6.7L21 8"></path><path d="M3 22v-6h6"></path><path d="M21 12a9 9 0 0 1-15 6.7L3 16"></path></svg>
          <span>{loading ? 'Refreshing...' : 'Apply Filters'}</span>
        </button>
      </div>


      {/* Command Center Zone Switcher */}
      <div className="oc-zone-nav">
        <button
          className={`oc-zone-tab ${activeZone === 'overview' ? 'active' : ''}`}
          onClick={() => setActiveZone('overview')}
        >
          <span>📊 Executive & Financials</span>
        </button>
        <button
          className={`oc-zone-tab ${activeZone === 'sites' ? 'active' : ''}`}
          onClick={() => setActiveZone('sites')}
        >
          <span>🏗️ Site Performance</span>
          <span className="oc-zone-badge">{sitesData.length}</span>
        </button>
        <button
          className={`oc-zone-tab ${activeZone === 'procurement' ? 'active' : ''}`}
          onClick={() => setActiveZone('procurement')}
        >
          <span>🤝 Vendors & Procurement</span>
          <span className="oc-zone-badge">{vendorsData.length}</span>
        </button>
        <button
          className={`oc-zone-tab ${activeZone === 'workorders' ? 'active' : ''}`}
          onClick={() => setActiveZone('workorders')}
        >
          <span>📝 Work Orders</span>
          <span className="oc-zone-badge">{workOrdersData?.list?.length || 0}</span>
        </button>
        <button
          className={`oc-zone-tab ${activeZone === 'profitloss' ? 'active' : ''}`}
          onClick={() => setActiveZone('profitloss')}
        >
          <span>📊 Profit & Loss</span>
        </button>
        <button
          className={`oc-zone-tab ${activeZone === 'salary' ? 'active' : ''}`}
          onClick={() => setActiveZone('salary')}
        >
          <span>💰 Salary Spends</span>
        </button>
        <button
          className={`oc-zone-tab ${activeZone === 'pulse' ? 'active' : ''}`}
          onClick={() => setActiveZone('pulse')}
        >
          <span>⚡ Operational Pulse & Alerts</span>
          <span className="oc-zone-badge">{alerts.length}</span>
        </button>
      </div>

      {/* ZONE 1: Executive Overview & Financial Intelligence */}
      {activeZone === 'overview' && (
        <>
          {/* Executive KPI Cards */}
          <div className="oc-grid-overview" style={{ gridTemplateColumns: 'repeat(5, 1fr)' }}>
            {executiveData?.kpis?.map((kpi, idx) => {
              const modernIcons = [
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" /></svg>,
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18" /><polyline points="17 6 23 6 23 12" /></svg>,
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><rect x="2" y="5" width="20" height="14" rx="2" /><line x1="2" y1="10" x2="22" y2="10" /></svg>,
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>,
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" /></svg>
              ];

              return (
                <div className="oc-card oc-kpi-card" key={idx}>
                  <div className="oc-kpi-header">
                    <div className="oc-kpi-title">{kpi.title}</div>
                    <div className="oc-kpi-icon" style={{ background: ['#eff6ff', '#f0fdf4', '#fff7ed', '#fef2f2', '#f5f3ff'][idx], color: ['#2563eb', '#16a34a', '#ea580c', '#dc2626', '#8b5cf6'][idx] }}>
                      {modernIcons[idx] || kpi.icon}
                    </div>
                  </div>
                  <div className="oc-kpi-value">{kpi.value}</div>
                  <div className="oc-trend-text">{kpi.percent} of total allocation</div>
                </div>
              );
            })}
          </div>

          {/* Financial Analytics Grid */}
          <div className="oc-grid-analytics" style={{ gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px' }}>
            <div className="oc-card">
              <div className="oc-section-header">Operational Health Rating</div>
              {executiveData && <Chart options={budgetUtilizationChart.options} series={budgetUtilizationChart.series} type="radialBar" height={240} />}
              <div style={{ display: 'flex', justifyContent: 'space-around', fontSize: '13px', borderTop: '1px solid #f1f5f9', paddingTop: '12px' }}>
                <div><span style={{ color: '#2563eb', fontWeight: 800 }}>●</span> Utilized: {executiveData?.kpis?.[1]?.value}</div>
                <div><span style={{ color: '#94a3b8', fontWeight: 800 }}>●</span> Available: {executiveData?.kpis?.[2]?.value}</div>
              </div>
            </div>

            <div className="oc-card">
              <div className="oc-section-header">Budget Distribution (By Category)</div>
              {financialData && <Chart options={expenseDistributionChart.options} series={expenseDistributionChart.series} type="donut" height={260} />}
            </div>

            <div className="oc-card">
              <div className="oc-section-header">Monthly Spending Run-Rate</div>
              {financialData && <Chart options={monthlySpendingChart.options} series={monthlySpendingChart.series} type="bar" height={240} />}
            </div>
          </div>

          {/* Detailed Budget Comparisons */}
          {/* <div className="oc-grid-analytics" style={{ gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
            <div className="oc-card">
              <div className="oc-section-header">Budget vs Actuals (By Category)</div>
              {financialData && <Chart options={budgetVsActualChart.options} series={budgetVsActualChart.series} type="bar" height={260} />}
            </div>

            <div className="oc-card">
              <div className="oc-section-header">Financial Year Budget Trajectory</div>
              {financialData && <Chart options={budgetTrendChart.options} series={budgetTrendChart.series} type="line" height={260} />}
            </div>
          </div> */}
        </>
      )}

      {/* ZONE 2: Site Performance & Field Operations */}
      {activeZone === 'sites' && (
        <>
          <div className="oc-section-header" style={{ justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <span>O&M Sites Directory ({filteredSites.length})</span>
              <div style={{ display: 'flex', gap: '6px' }}>
                {['all', 'normal', 'warning', 'critical'].map(st => (
                  <button
                    key={st}
                    onClick={() => { setSiteStatusFilter(st); setSitePage(1); }}
                    style={{
                      padding: '4px 10px',
                      borderRadius: '16px',
                      border: '1px solid #cbd5e1',
                      background: siteStatusFilter === st ? '#2563eb' : '#fff',
                      color: siteStatusFilter === st ? '#fff' : '#64748b',
                      fontSize: '11px',
                      fontWeight: 700,
                      cursor: 'pointer',
                      textTransform: 'capitalize'
                    }}
                  >
                    {st}
                  </button>
                ))}
              </div>
            </div>

            <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
              <input
                type="text"
                placeholder="Search sites by name..."
                value={siteSearch}
                onChange={e => { setSiteSearch(e.target.value); setSitePage(1); }}
                style={{ padding: '7px 14px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '13px', outline: 'none', width: '220px' }}
              />
              <div style={{ display: 'flex', gap: '6px', alignItems: 'center', fontSize: '13px' }}>
                <button onClick={() => setSitePage(p => Math.max(1, p - 1))} disabled={sitePage === 1} style={{ padding: '4px 10px', borderRadius: '6px', border: '1px solid #cbd5e1', background: sitePage === 1 ? '#f1f5f9' : '#fff', cursor: sitePage === 1 ? 'not-allowed' : 'pointer' }}>&lt;</button>
                <span style={{ color: '#64748b', fontWeight: 600 }}>{sitePage} / {totalSitePages}</span>
                <button onClick={() => setSitePage(p => Math.min(totalSitePages, p + 1))} disabled={sitePage === totalSitePages} style={{ padding: '4px 10px', borderRadius: '6px', border: '1px solid #cbd5e1', background: sitePage === totalSitePages ? '#f1f5f9' : '#fff', cursor: sitePage === totalSitePages ? 'not-allowed' : 'pointer' }}>&gt;</button>
              </div>
            </div>
          </div>

          <div className="oc-site-grid">
            {currentSites.length > 0 ? currentSites.map((site, idx) => {
              const isHighRatio = parseFloat(site.spentPercent) > 80;
              return (
                <div className="oc-site-card-compact" key={idx} onClick={() => openSiteDrawer(site)}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                    <div className="oc-site-card-title">{site.name}</div>
                    <span
                      className="oc-site-card-badge"
                      style={{
                        backgroundColor: site.status === 'Warning' ? '#f59e0b' : site.status === 'Critical' ? '#ef4444' : '#10b981',
                        color: '#fff'
                      }}
                    >
                      {site.status || 'Normal'}
                    </span>
                  </div>

                  <div className="oc-site-stats">
                    <span>Budget Consumed</span>
                    <span style={{ fontWeight: 700, color: isHighRatio ? '#ef4444' : '#0f172a' }}>{site.spent} ({site.spentPercent}%)</span>
                  </div>

                  <div className="oc-progress-container">
                    <div
                      className="oc-progress-bar"
                      style={{
                        width: site.spentPercent + '%',
                        backgroundColor: isHighRatio ? '#ef4444' : '#2563eb'
                      }}
                    ></div>
                  </div>

                  <div className="oc-site-meta">
                    <div className="oc-site-meta-item">💰 {site.budget}</div>
                    <div className="oc-site-meta-item">👷 {site.activeWorkers || 0} Staff</div>
                  </div>
                </div>
              );
            }) : (
              <div style={{ gridColumn: '1 / -1', padding: '48px', textAlign: 'center', color: '#64748b', background: '#fff', borderRadius: '16px', border: '1px dashed #cbd5e1' }}>
                No sites found matching the search and filter criteria.
              </div>
            )}
          </div>

          {/* Top 5 Costliest Sites Table */}
          <div className="oc-card" style={{ marginTop: '24px' }}>
            <div className="oc-section-header">Top High-Utilization Sites Summary</div>
            <table className="oc-table">
              <thead>
                <tr>
                  <th>Site Name</th>
                  <th>Allocated Budget</th>
                  <th>Utilized Amount</th>
                  <th>Utilization Rate</th>
                </tr>
              </thead>
              <tbody>
                {sitesData.slice(0, 5).map(s => (
                  <tr key={s.id} onClick={() => openSiteDrawer(s)} style={{ cursor: 'pointer' }} className="oc-table-row-hover">
                    <td style={{ fontWeight: 600 }}>{s.name}</td>
                    <td>{s.budget}</td>
                    <td>{s.spent}</td>
                    <td style={{ fontWeight: 700, color: parseFloat(s.spentPercent) > 80 ? '#ef4444' : '#10b981' }}>{s.spentPercent}%</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* ZONE 3: Vendors & Procurement Pipeline */}
      {activeZone === 'procurement' && (() => {
        const totalDisbursed = vendorsData.reduce((sum, v) => sum + (v.totalPaidRaw || 0), 0);
        const totalOutstanding = vendorsData.reduce((sum, v) => sum + (v.pendingRaw || 0), 0);
        const totalProcurement = totalDisbursed + totalOutstanding;

        const topVendorsChart = {
          options: {
            chart: { type: 'bar', toolbar: { show: false }, background: 'transparent' },
            plotOptions: { bar: { horizontal: false, borderRadius: 5, columnWidth: '50%' } },
            colors: ['#2563eb', '#10b981'],
            dataLabels: { enabled: false },
            xaxis: {
              categories: vendorsData.slice(0, 5).map(v => v.firmName || v.name),
              labels: { style: { fontSize: '10px', fontWeight: 600 } }
            },
            yaxis: { labels: { formatter: formatChartCurrency } },
            legend: { position: 'top', horizontalAlign: 'right', fontSize: '11px' },
            grid: { borderColor: 'rgba(226, 232, 240, 0.8)', strokeDashArray: 4 },
            tooltip: { y: { formatter: formatChartCurrency } }
          },
          series: [
            { name: 'Total Committed (POs)', data: vendorsData.slice(0, 5).map(v => (v.totalPaidRaw || 0) + (v.pendingRaw || 0)) },
            { name: 'Total Paid (Disbursed)', data: vendorsData.slice(0, 5).map(v => v.totalPaidRaw || 0) }
          ]
        };

        return (
          <>
            {/* Procurement Summary Cards */}
            <div className="oc-grid-overview" style={{ gridTemplateColumns: 'repeat(4, 1fr)', marginBottom: '24px' }}>
              <div className="oc-card oc-kpi-card" style={{ background: 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)', border: '1px solid #bfdbfe' }}>
                <div className="oc-kpi-header">
                  <div className="oc-kpi-title" style={{ color: '#1e40af' }}>Total Procurement Volume</div>
                  <div className="oc-kpi-icon" style={{ background: '#2563eb', color: '#fff' }}>💼</div>
                </div>
                <div className="oc-kpi-value" style={{ color: '#1e3a8a' }}>{formatChartCurrency(totalProcurement)}</div>
                <div className="oc-trend-text" style={{ color: '#1e40af' }}>Committed POs + Clearances</div>
              </div>

              <div className="oc-card oc-kpi-card" style={{ background: 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)', border: '1px solid #bbf7d0' }}>
                <div className="oc-kpi-header">
                  <div className="oc-kpi-title" style={{ color: '#166534' }}>Disbursed to Date</div>
                  <div className="oc-kpi-icon" style={{ background: '#16a34a', color: '#fff' }}>💸</div>
                </div>
                <div className="oc-kpi-value" style={{ color: '#14532d' }}>{formatChartCurrency(totalDisbursed)}</div>
                <div className="oc-trend-text" style={{ color: '#166534' }}>Actually Paid to Vendors</div>
              </div>

              <div className="oc-card oc-kpi-card" style={{ background: 'linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%)', border: '1px solid #fed7aa' }}>
                <div className="oc-kpi-header">
                  <div className="oc-kpi-title" style={{ color: '#9a3412' }}>Outstanding Clearance</div>
                  <div className="oc-kpi-icon" style={{ background: '#ea580c', color: '#fff' }}>⌛</div>
                </div>
                <div className="oc-kpi-value" style={{ color: '#7c2d12' }}>{formatChartCurrency(totalOutstanding)}</div>
                <div className="oc-trend-text" style={{ color: '#9a3412' }}>Pending Approval/Disbursal</div>
              </div>

              <div className="oc-card oc-kpi-card" style={{ background: 'linear-gradient(135deg, #f5f3ff 0%, #e9e3ff 100%)', border: '1px solid #ddd6fe' }}>
                <div className="oc-kpi-header">
                  <div className="oc-kpi-title" style={{ color: '#5b21b6' }}>Engaged SCM Vendors</div>
                  <div className="oc-kpi-icon" style={{ background: '#7c3aed', color: '#fff' }}>🤝</div>
                </div>
                <div className="oc-kpi-value" style={{ color: '#4c1d95' }}>{vendorsData.length}</div>
                <div className="oc-trend-text" style={{ color: '#5b21b6' }}>Active Business Partnerships</div>
              </div>
            </div>

            {/* Split Screen Directory vs Spend Graph */}
            <div className="oc-grid-analytics" style={{ gridTemplateColumns: '1.4fr 1fr', gap: '20px' }}>

              {/* Interactive Vendor Directory */}
              <div className="oc-card">
                <div className="oc-section-header" style={{ justifyContent: 'space-between', marginBottom: '16px' }}>
                  <span style={{ fontSize: '15px' }}>SCM Vendor Registry Directory</span>

                  <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <input
                      type="text"
                      placeholder="Search name, city..."
                      value={vendorSearch}
                      onChange={e => { setVendorSearch(e.target.value); setVendorPage(1); }}
                      style={{ padding: '6px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '12px', outline: 'none', width: '160px' }}
                    />
                    <div style={{ display: 'flex', gap: '4px', alignItems: 'center', fontSize: '12px' }}>
                      <button onClick={() => setVendorPage(p => Math.max(1, p - 1))} disabled={vendorPage === 1} style={{ padding: '3px 8px', borderRadius: '4px', border: '1px solid #cbd5e1', background: '#fff', cursor: 'pointer' }}>&lt;</button>
                      <span style={{ color: '#64748b', fontWeight: 600 }}>{vendorPage}/{totalVendorPages}</span>
                      <button onClick={() => setVendorPage(p => Math.min(totalVendorPages, p + 1))} disabled={vendorPage === totalVendorPages} style={{ padding: '3px 8px', borderRadius: '4px', border: '1px solid #cbd5e1', background: '#fff', cursor: 'pointer' }}>&gt;</button>
                    </div>
                  </div>
                </div>

                <table className="oc-table" style={{ fontSize: '12px' }}>
                  <thead>
                    <tr>
                      <th>Firm Details</th>
                      <th>Location</th>
                      <th>Engaged Sites</th>
                      <th style={{ textAlign: 'right' }}>POs Count</th>
                      <th style={{ textAlign: 'right' }}>Disbursed</th>
                      <th style={{ textAlign: 'right' }}>Outstanding</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentVendors.length > 0 ? currentVendors.map((v, idx) => (
                      <tr
                        key={idx}
                        onClick={() => { setSelectedVendorDetails(v); setVendorDrawerOpen(true); }}
                        style={{ cursor: 'pointer' }}
                        className="oc-table-row-hover"
                      >
                        <td>
                          <div style={{ fontWeight: 700, color: '#0f172a' }}>{v.firmName}</div>
                          <div style={{ fontSize: '10px', color: '#64748b' }}>GSTIN: {v.gstNumber}</div>
                        </td>
                        <td>{v.city}, {v.state}</td>
                        <td style={{ fontWeight: 600, color: '#2563eb', textAlign: 'center' }}>{v.siteCount}</td>
                        <td style={{ fontWeight: 600, textAlign: 'center' }}>{v.poCount}</td>
                        <td style={{ color: '#16a34a', fontWeight: 700, textAlign: 'right' }}>{v.totalPaid}</td>
                        <td style={{ color: '#dc2626', fontWeight: 700, textAlign: 'right' }}>{v.pendingAmount}</td>
                      </tr>
                    )) : (
                      <tr>
                        <td colSpan="6" style={{ textAlign: 'center', color: '#64748b', padding: '30px' }}>No SCM vendors match your search.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* Vendor Spend Analytics & Recent Tickets */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                <div className="oc-card">
                  <div className="oc-section-header">Top 5 Vendors Financial Comparison</div>
                  {vendorsData.length > 0 && (
                    <Chart options={topVendorsChart.options} series={topVendorsChart.series} type="bar" height={220} />
                  )}
                </div>

                <div className="oc-card">
                  <div className="oc-section-header">Recent Payment Clearance Log</div>
                  <table className="oc-table" style={{ fontSize: '12px' }}>
                    <thead>
                      <tr>
                        <th>Ticket #</th>
                        <th>Amount</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paymentsData.slice(0, 5).map((p, idx) => (
                        <tr
                          key={idx}
                          onClick={() => openPaymentTicketDetail(p)}
                          style={{ cursor: 'pointer' }}
                          className="oc-table-row-hover"
                        >
                          <td style={{ fontWeight: 600, color: '#2563eb' }}>{p.ticketNo}</td>
                          <td style={{ fontWeight: 700 }}>{p.amount}</td>
                          <td>
                            <span className={`oc-status-badge oc-status-${p.status ? p.status.toLowerCase() : 'pending'}`}>
                              {p.status}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

            </div>
          </>
        );
      })()}
      {/* ZONE 3B: Work Orders Analytics & Distribution */}
      {activeZone === 'workorders' && (() => {
        const filteredWorkOrders = workOrdersData.list.filter(wo => {
          const term = workOrderSearch.toLowerCase();
          return (wo.workOrderNumber && wo.workOrderNumber.toLowerCase().includes(term)) ||
            (wo.title && wo.title.toLowerCase().includes(term)) ||
            (wo.siteName && wo.siteName.toLowerCase().includes(term));
        });

        const woPerPage = 6;
        const totalWOPages = Math.ceil(filteredWorkOrders.length / woPerPage) || 1;
        const currentWO = filteredWorkOrders.slice((workOrderPage - 1) * woPerPage, workOrderPage * woPerPage);

        const workOrdersTrendChart = {
          options: {
            chart: { type: 'area', toolbar: { show: false }, background: 'transparent' },
            colors: ['#8b5cf6', '#2563eb', '#10b981'],
            dataLabels: { enabled: false },
            stroke: { curve: 'smooth', width: 2.5 },
            fill: {
              type: 'gradient',
              gradient: { shadeIntensity: 1, opacityFrom: 0.25, opacityTo: 0.05 }
            },
            xaxis: {
              categories: workOrdersData.distribution?.categories || [],
              labels: { style: { fontSize: '10px', fontWeight: 600, colors: '#64748b' } }
            },
            yaxis: { labels: { formatter: formatChartCurrency } },
            legend: { position: 'top', horizontalAlign: 'right', fontSize: '11px' },
            grid: { borderColor: 'rgba(226, 232, 240, 0.8)', strokeDashArray: 4 },
            tooltip: { y: { formatter: formatChartCurrency } }
          },
          series: [
            { name: 'Valued (Registered)', data: workOrdersData.distribution?.valued || [] },
            { name: 'Invoiced Amount', data: workOrdersData.distribution?.invoiced || [] },
            { name: 'Cleared Amount', data: workOrdersData.distribution?.cleared || [] }
          ]
        };

        return (
          <>
            {/* Summary KPI Cards */}
            <div className="oc-grid-overview" style={{ gridTemplateColumns: 'repeat(4, 1fr)', marginBottom: '24px' }}>
              <div className="oc-card oc-kpi-card" style={{ background: 'linear-gradient(135deg, #f5f3ff 0%, #e9e3ff 100%)', border: '1px solid #ddd6fe' }}>
                <div className="oc-kpi-header">
                  <div className="oc-kpi-title" style={{ color: '#5b21b6' }}>Total Valued Orders</div>
                  <div className="oc-kpi-icon" style={{ background: '#8b5cf6', color: '#fff' }}>📝</div>
                </div>
                <div className="oc-kpi-value" style={{ color: '#4c1d95' }}>{workOrdersData.summary?.totalValued}</div>
                <div className="oc-trend-text" style={{ color: '#5b21b6' }}>{workOrdersData.summary?.totalCount} Work Orders Registered</div>
              </div>

              <div className="oc-card oc-kpi-card" style={{ background: 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)', border: '1px solid #bfdbfe' }}>
                <div className="oc-kpi-header">
                  <div className="oc-kpi-title" style={{ color: '#1e40af' }}>Total Invoiced To Date</div>
                  <div className="oc-kpi-icon" style={{ background: '#2563eb', color: '#fff' }}>📄</div>
                </div>
                <div className="oc-kpi-value" style={{ color: '#1e3a8a' }}>{workOrdersData.summary?.totalInvoiced}</div>
                <div className="oc-trend-text" style={{ color: '#1e40af' }}>Billed amount from invoices</div>
              </div>

              <div className="oc-card oc-kpi-card" style={{ background: 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)', border: '1px solid #bbf7d0' }}>
                <div className="oc-kpi-header">
                  <div className="oc-kpi-title" style={{ color: '#166534' }}>Cleared (Paid) Value</div>
                  <div className="oc-kpi-icon" style={{ background: '#16a34a', color: '#fff' }}>💰</div>
                </div>
                <div className="oc-kpi-value" style={{ color: '#14532d' }}>{workOrdersData.summary?.totalCleared}</div>
                <div className="oc-trend-text" style={{ color: '#166534' }}>Cash inflow cleared by client</div>
              </div>

              <div className="oc-card oc-kpi-card" style={{ background: 'linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%)', border: '1px solid #fed7aa' }}>
                <div className="oc-kpi-header">
                  <div className="oc-kpi-title" style={{ color: '#9a3412' }}>Outstanding Billing</div>
                  <div className="oc-kpi-icon" style={{ background: '#ea580c', color: '#fff' }}>⏳</div>
                </div>
                <div className="oc-kpi-value" style={{ color: '#7c2d12' }}>{workOrdersData.summary?.totalOutstanding}</div>
                <div className="oc-trend-text" style={{ color: '#9a3412' }}>Yet to be billed/invoiced</div>
              </div>
            </div>

            {/* Split Screen Directory vs Trend Graph */}
            <div className="oc-grid-analytics" style={{ gridTemplateColumns: '1.6fr 1fr', gap: '20px' }}>

              {/* Interactive Work Order Directory */}
              <div className="oc-card">
                <div className="oc-section-header" style={{ justifyContent: 'space-between', marginBottom: '16px' }}>
                  <span style={{ fontSize: '15px' }}>Work Orders Registry Directory</span>

                  <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <input
                      type="text"
                      placeholder="Search order #, site..."
                      value={workOrderSearch}
                      onChange={e => { setWorkOrderSearch(e.target.value); setWorkOrderPage(1); }}
                      style={{ padding: '6px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '12px', outline: 'none', width: '160px' }}
                    />
                    <div style={{ display: 'flex', gap: '4px', alignItems: 'center', fontSize: '12px' }}>
                      <button onClick={() => setWorkOrderPage(p => Math.max(1, p - 1))} disabled={workOrderPage === 1} style={{ padding: '3px 8px', borderRadius: '4px', border: '1px solid #cbd5e1', background: '#fff', cursor: 'pointer' }}>&lt;</button>
                      <span style={{ color: '#64748b', fontWeight: 600 }}>{workOrderPage}/{totalWOPages}</span>
                      <button onClick={() => setWorkOrderPage(p => Math.min(totalWOPages, p + 1))} disabled={workOrderPage === totalWOPages} style={{ padding: '3px 8px', borderRadius: '4px', border: '1px solid #cbd5e1', background: '#fff', cursor: 'pointer' }}>&gt;</button>
                    </div>
                  </div>
                </div>

                <div style={{ overflowX: 'auto', width: '100%' }}>
                  <table className="oc-table" style={{ fontSize: '12px', minWidth: '760px' }}>
                    <thead>
                      <tr>
                        <th>Order Details</th>
                        <th>Assigned Site</th>
                        <th>Registered Date</th>
                        <th style={{ textAlign: 'right' }}>Total Valued</th>
                        <th style={{ textAlign: 'right' }}>Invoiced</th>
                        <th style={{ textAlign: 'right' }}>Cleared (Paid)</th>
                        <th style={{ textAlign: 'center' }}>Billed %</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentWO.length > 0 ? currentWO.map((wo, idx) => (
                        <tr
                          key={idx}
                          onClick={() => window.open(`${window.location.origin}${RoutesLink.work_order_detail}/${wo.id}`, '_blank')}
                          style={{ cursor: 'pointer' }}
                          className="oc-table-row-hover"
                        >
                          <td>
                            <div style={{ fontWeight: 700, color: '#0f172a' }}>{wo.workOrderNumber}</div>
                            <div style={{ fontSize: '10px', color: '#64748b' }}>{wo.title}</div>
                          </td>
                          <td style={{ fontWeight: 600, color: '#2563eb' }}>{wo.siteName}</td>
                          <td>{wo.date}</td>
                          <td style={{ fontWeight: 700, textAlign: 'right' }}>{wo.totalAmount}</td>
                          <td style={{ color: '#2563eb', fontWeight: 700, textAlign: 'right' }}>{wo.invoicedAmount}</td>
                          <td style={{ color: '#16a34a', fontWeight: 700, textAlign: 'right' }}>{wo.clearedAmount}</td>
                          <td style={{ textAlign: 'center' }}>
                            <span style={{
                              background: '#eff6ff',
                              color: '#2563eb',
                              padding: '2px 6px',
                              borderRadius: '4px',
                              fontWeight: 700,
                              fontSize: '10px'
                            }}>
                              {wo.progressPercent}%
                            </span>
                          </td>
                        </tr>
                      )) : (
                        <tr>
                          <td colSpan="7" style={{ textAlign: 'center', color: '#64748b', padding: '30px' }}>No work orders match your search.</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Monthly Trend Distribution Chart */}
              <div className="oc-card">
                <div className="oc-section-header">Monthly Work Orders Distribution</div>
                {workOrdersData.list.length > 0 && (
                  <Chart options={workOrdersTrendChart.options} series={workOrdersTrendChart.series} type="area" height={360} />
                )}
              </div>
            </div>
          </>
        );
      })()}

      {/* ZONE 3C: Profit & Loss Analysis */}
      {activeZone === 'profitloss' && (() => {
        const monthsList = [
          { value: 'all', label: 'All Months' },
          { value: 'Apr', label: 'April' },
          { value: 'May', label: 'May' },
          { value: 'Jun', label: 'June' },
          { value: 'Jul', label: 'July' },
          { value: 'Aug', label: 'August' },
          { value: 'Sep', label: 'September' },
          { value: 'Oct', label: 'October' },
          { value: 'Nov', label: 'November' },
          { value: 'Dec', label: 'December' },
          { value: 'Jan', label: 'January' },
          { value: 'Feb', label: 'February' },
          { value: 'Mar', label: 'March' }
        ];

        const monthsOrder = ['Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'];
        const monthNamesFull = {
          'Apr': 'April', 'May': 'May', 'Jun': 'June', 'Jul': 'July', 'Aug': 'August', 'Sep': 'September',
          'Oct': 'October', 'Nov': 'November', 'Dec': 'December', 'Jan': 'January', 'Feb': 'February', 'Mar': 'March'
        };

        // 1. Filter ledger items by selected month
        let filteredByMonth = profitLossData.ledger || [];
        if (plMonthFilter !== 'all') {
          filteredByMonth = filteredByMonth.filter(item => {
            if (!item.date) return false;
            const parts = item.date.split('-');
            const monthsShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            const m = monthsShort[parseInt(parts[1], 10) - 1];
            return m === plMonthFilter;
          });
        }

        // 2. Filter ledger for Ledger Tab
        const filteredLedger = filteredByMonth.filter(item => {
          if (plTypeFilter !== 'all' && item.type !== plTypeFilter) {
            return false;
          }
          const term = profitLossSearch.toLowerCase();
          return (item.reference && item.reference.toLowerCase().includes(term)) ||
            (item.party && item.party.toLowerCase().includes(term)) ||
            (item.siteName && item.siteName.toLowerCase().includes(term)) ||
            (item.type && item.type.toLowerCase().includes(term)) ||
            (item.status && item.status.toLowerCase().includes(term));
        });

        const ledgerPerPage = profitLossLimit;
        const totalLedgerPages = Math.ceil(filteredLedger.length / ledgerPerPage) || 1;
        const currentLedger = filteredLedger.slice((profitLossPage - 1) * ledgerPerPage, profitLossPage * ledgerPerPage);

        // 3. Recalculate summary metrics dynamically based on month filter
        let revenueVal = 0;
        let expenseVal = 0;
        let poVal = 0;
        let salaryVal = 0;
        let generalVal = 0;

        filteredByMonth.forEach(item => {
          revenueVal += item.credit;
          expenseVal += item.debit;
          if (item.debit > 0) {
            if (item.type === 'PO') poVal += item.debit;
            else if (item.type === 'Salary') salaryVal += item.debit;
            else if (item.type === 'Payment') generalVal += item.debit;
          }
        });

        const netProfitVal = revenueVal - expenseVal;
        const marginVal = revenueVal > 0 ? ((netProfitVal / revenueVal) * 100).toFixed(1) + '%' : '0%';

        // 4. Compute Site-Wise Aggregations
        const headOfficeKey = 'headoffice';
        const siteMap = {};

        // Seed with master sites from master list
        sitesList.forEach(s => {
          const sId = String(s.id);
          const cName = s.company ? s.company.name : (s.Company ? s.Company.name : 'N/A');
          siteMap[sId] = {
            siteId: s.id,
            siteName: s.name,
            companyName: cName,
            // for active month filter
            filteredRevenue: 0,
            filteredSalaryExpense: 0,
            filteredPoExpense: 0,
            filteredGeneralExpense: 0,
            filteredPaymentExpense: 0,
            filteredTotalExpense: 0,
            filteredNetProfit: 0,
            filteredMargin: '0%',
            // total for full FY
            totalRevenue: 0,
            totalSalaryExpense: 0,
            totalPoExpense: 0,
            totalGeneralExpense: 0,
            totalPaymentExpense: 0,
            totalExpense: 0,
            totalNetProfit: 0,
            totalMargin: '0%',
            months: {}
          };
          monthsOrder.forEach(m => {
            siteMap[sId].months[m] = {
              month: m,
              monthName: monthNamesFull[m],
              revenue: 0,
              salaryExpense: 0,
              poExpense: 0,
              generalExpense: 0,
              paymentExpense: 0,
              totalExpense: 0,
              netProfit: 0,
              margin: '0%'
            };
          });
        });

        // Seed Head Office / Corporate Entry
        siteMap[headOfficeKey] = {
          siteId: null,
          siteName: '🏢 Head Office & Corporate Expenses (General)',
          companyName: 'Corporate / Unassigned',
          filteredRevenue: 0,
          filteredSalaryExpense: 0,
          filteredPoExpense: 0,
          filteredGeneralExpense: 0,
          filteredPaymentExpense: 0,
          filteredTotalExpense: 0,
          filteredNetProfit: 0,
          filteredMargin: '0%',
          totalRevenue: 0,
          totalSalaryExpense: 0,
          totalPoExpense: 0,
          totalGeneralExpense: 0,
          totalPaymentExpense: 0,
          totalExpense: 0,
          totalNetProfit: 0,
          totalMargin: '0%',
          months: {}
        };
        monthsOrder.forEach(m => {
          siteMap[headOfficeKey].months[m] = {
            month: m,
            monthName: monthNamesFull[m],
            revenue: 0,
            salaryExpense: 0,
            poExpense: 0,
            generalExpense: 0,
            paymentExpense: 0,
            totalExpense: 0,
            netProfit: 0,
            margin: '0%'
          };
        });

        (profitLossData.ledger || []).forEach(item => {
          const targetKey = (item.siteId && siteMap[String(item.siteId)]) ? String(item.siteId) : headOfficeKey;
          const sm = siteMap[targetKey];
          if (!sm) return;

          const d = new Date(item.dateRaw || item.date);
          const monthsShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
          const itemMonth = item.date ? monthsShort[parseInt(item.date.split('-')[1], 10) - 1] : d.toLocaleString('en-US', { month: 'short' });

          const rev = item.credit || 0;
          const deb = item.debit || 0;
          let sal = 0;
          let po = 0;
          let gen = 0;

          if (deb > 0) {
            if (item.type === 'Salary') sal = deb;
            else if (item.type === 'PO') po = deb;
            else if (item.type === 'Payment') gen = deb;
          }

          sm.totalRevenue += rev;
          sm.totalSalaryExpense += sal;
          sm.totalPoExpense += po;
          sm.totalGeneralExpense += gen;
          sm.totalPaymentExpense += (po + gen);
          sm.totalExpense += deb;

          if (sm.months[itemMonth]) {
            const mm = sm.months[itemMonth];
            mm.revenue += rev;
            mm.salaryExpense += sal;
            mm.poExpense += po;
            mm.generalExpense += gen;
            mm.paymentExpense += (po + gen);
            mm.totalExpense += deb;
          }

          if (plMonthFilter === 'all' || plMonthFilter === itemMonth) {
            sm.filteredRevenue += rev;
            sm.filteredSalaryExpense += sal;
            sm.filteredPoExpense += po;
            sm.filteredGeneralExpense += gen;
            sm.filteredPaymentExpense += (po + gen);
            sm.filteredTotalExpense += deb;
          }
        });

        const allSitesList = Object.values(siteMap).filter(s => {
          if (s.siteName.includes('Head Office') && s.totalRevenue === 0 && s.totalExpense === 0) return false;
          return true;
        }).map(s => {
          s.filteredNetProfit = s.filteredRevenue - s.filteredTotalExpense;
          s.filteredMargin = s.filteredRevenue > 0 ? ((s.filteredNetProfit / s.filteredRevenue) * 100).toFixed(1) + '%' : '0%';

          s.totalNetProfit = s.totalRevenue - s.totalExpense;
          s.totalMargin = s.totalRevenue > 0 ? ((s.totalNetProfit / s.totalRevenue) * 100).toFixed(1) + '%' : '0%';

          monthsOrder.forEach(m => {
            const mm = s.months[m];
            mm.netProfit = mm.revenue - mm.totalExpense;
            mm.margin = mm.revenue > 0 ? ((mm.netProfit / mm.revenue) * 100).toFixed(1) + '%' : '0%';
          });

          return s;
        }).sort((a, b) => b.filteredRevenue - a.filteredRevenue);

        // Filter sites by search
        const filteredSites = allSitesList.filter(s => {
          if (!plSiteSearch) return true;
          const term = plSiteSearch.toLowerCase();
          return (s.siteName && s.siteName.toLowerCase().includes(term)) ||
            (s.companyName && s.companyName.toLowerCase().includes(term));
        });

        const siteTotalPages = Math.ceil(filteredSites.length / plSiteLimit) || 1;
        const currentSites = filteredSites.slice((plSitePage - 1) * plSiteLimit, plSitePage * plSiteLimit);

        // 5. Compute Month-Wise 12 Months Financial Statement
        const monthlyStatementData = monthsOrder.map(m => {
          let mRev = 0, mSal = 0, mPo = 0, mGen = 0, mTotExp = 0;
          (profitLossData.ledger || []).forEach(item => {
            const d = new Date(item.dateRaw || item.date);
            const monthsShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            const itemMonth = item.date ? monthsShort[parseInt(item.date.split('-')[1], 10) - 1] : d.toLocaleString('en-US', { month: 'short' });
            if (itemMonth === m) {
              mRev += item.credit || 0;
              mTotExp += item.debit || 0;
              if (item.type === 'Salary') mSal += item.debit;
              else if (item.type === 'PO') mPo += item.debit;
              else if (item.type === 'Payment') mGen += item.debit;
            }
          });
          const mNet = mRev - mTotExp;
          const mMargin = mRev > 0 ? ((mNet / mRev) * 100).toFixed(1) + '%' : '0%';
          return {
            shortMonth: m,
            monthName: monthNamesFull[m],
            revenue: mRev,
            salaryExpense: mSal,
            poExpense: mPo,
            generalExpense: mGen,
            paymentExpense: mPo + mGen,
            totalExpense: mTotExp,
            netProfit: mNet,
            margin: mMargin
          };
        });

        // Totals for Month Statement
        const fullYearRevenue = monthlyStatementData.reduce((sum, m) => sum + m.revenue, 0);
        const fullYearSalary = monthlyStatementData.reduce((sum, m) => sum + m.salaryExpense, 0);
        const fullYearPO = monthlyStatementData.reduce((sum, m) => sum + m.poExpense, 0);
        const fullYearGen = monthlyStatementData.reduce((sum, m) => sum + m.generalExpense, 0);
        const fullYearPayment = fullYearPO + fullYearGen;
        const fullYearTotalExp = monthlyStatementData.reduce((sum, m) => sum + m.totalExpense, 0);
        const fullYearNetProfit = fullYearRevenue - fullYearTotalExp;
        const fullYearMargin = fullYearRevenue > 0 ? ((fullYearNetProfit / fullYearRevenue) * 100).toFixed(1) + '%' : '0%';

        const toggleSiteExpand = (id) => {
          setExpandedSiteIds(prev =>
            prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
          );
        };

        const toggleExpandAll = () => {
          if (expandedSiteIds.length === currentSites.length && currentSites.length > 0) {
            setExpandedSiteIds([]);
          } else {
            setExpandedSiteIds(currentSites.map(s => s.siteId || s.siteName));
          }
        };

        return (
          <>
            {/* P&L Header & Month Selector */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <div>
                <h3 style={{ fontSize: '18px', fontWeight: 700, color: '#0f172a', margin: 0 }}>Profit & Loss Intelligence</h3>
                <div style={{ fontSize: '12px', color: '#64748b', marginTop: '2px' }}>Comprehensive site-wise & month-wise management financials</div>
              </div>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <span style={{ fontSize: '12px', fontWeight: 600, color: '#64748b' }}>Accounting Month:</span>
                <select
                  value={plMonthFilter}
                  onChange={e => { setPlMonthFilter(e.target.value); setProfitLossPage(1); setPlSitePage(1); }}
                  style={{ padding: '6px 14px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '13px', outline: 'none', background: '#fff', fontWeight: 600, color: '#1e293b', cursor: 'pointer', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}
                >
                  {monthsList.map(m => (
                    <option key={m.value} value={m.value}>{m.label}</option>
                  ))}
                </select>
              </div>
            </div>

            {/* Profit & Loss Overview Cards */}
            <div className="oc-grid-overview" style={{ gridTemplateColumns: 'repeat(5, 1fr)', gap: '16px', marginBottom: '24px' }}>
              <div className="oc-card oc-kpi-card" style={{ background: 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)', border: '1px solid #bfdbfe' }}>
                <div className="oc-kpi-header">
                  <div className="oc-kpi-title" style={{ color: '#1e40af' }}>Revenue (Invoiced)</div>
                  <div className="oc-kpi-icon" style={{ background: '#2563eb', color: '#fff' }}>📈</div>
                </div>
                <div className="oc-kpi-value" style={{ color: '#1e3a8a' }}>₹ {revenueVal.toLocaleString('en-IN')}</div>
                <div className="oc-trend-text" style={{ color: '#1e40af' }}>
                  {plMonthFilter === 'all' ? 'Full Financial Year' : `${monthNamesFull[plMonthFilter] || plMonthFilter} Billing`}
                </div>
              </div>

              <div className="oc-card oc-kpi-card" style={{ background: 'linear-gradient(135deg, #fdf4ff 0%, #fae8ff 100%)', border: '1px solid #f5d0fe' }}>
                <div className="oc-kpi-header">
                  <div className="oc-kpi-title" style={{ color: '#a21caf' }}>Salary Expenses</div>
                  <div className="oc-kpi-icon" style={{ background: '#d946ef', color: '#fff' }}>💼</div>
                </div>
                <div className="oc-kpi-value" style={{ color: '#701a75' }}>₹ {salaryVal.toLocaleString('en-IN')}</div>
                <div className="oc-trend-text" style={{ color: '#a21caf' }}>Salary ticket payments</div>
              </div>

              <div className="oc-card oc-kpi-card" style={{ background: 'linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%)', border: '1px solid #fed7aa' }}>
                <div className="oc-kpi-header">
                  <div className="oc-kpi-title" style={{ color: '#c2410c' }}>Payment Expenses</div>
                  <div className="oc-kpi-icon" style={{ background: '#ea580c', color: '#fff' }}>💸</div>
                </div>
                <div className="oc-kpi-value" style={{ color: '#7c2d12' }}>₹ {(poVal + generalVal).toLocaleString('en-IN')}</div>
                <div className="oc-trend-text" style={{ color: '#c2410c' }}>PO (₹{poVal.toLocaleString('en-IN')}) + General (₹{generalVal.toLocaleString('en-IN')})</div>
              </div>

              <div className="oc-card oc-kpi-card" style={{
                background: netProfitVal >= 0
                  ? 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)'
                  : 'linear-gradient(135deg, #fff5f5 0%, #fed7d7 100%)',
                border: netProfitVal >= 0
                  ? '1px solid #bbf7d0'
                  : '1px solid #feb2b2'
              }}>
                <div className="oc-kpi-header">
                  <div className="oc-kpi-title" style={{ color: netProfitVal >= 0 ? '#166534' : '#9b2c2c' }}>Net Profit / (Loss)</div>
                  <div className="oc-kpi-icon" style={{
                    background: netProfitVal >= 0 ? '#16a34a' : '#e53e3e',
                    color: '#fff'
                  }}>💰</div>
                </div>
                <div className="oc-kpi-value" style={{ color: netProfitVal >= 0 ? '#14532d' : '#742a2a' }}>
                  ₹ {netProfitVal.toLocaleString('en-IN')}
                </div>
                <div className="oc-trend-text" style={{ color: netProfitVal >= 0 ? '#166534' : '#9b2c2c' }}>
                  Revenue − Total Expenses
                </div>
              </div>

              <div className="oc-card oc-kpi-card" style={{ background: 'linear-gradient(135deg, #f5f3ff 0%, #e9e3ff 100%)', border: '1px solid #ddd6fe' }}>
                <div className="oc-kpi-header">
                  <div className="oc-kpi-title" style={{ color: '#5b21b6' }}>Profit Margin</div>
                  <div className="oc-kpi-icon" style={{ background: '#7c3aed', color: '#fff' }}>📊</div>
                </div>
                <div className="oc-kpi-value" style={{ color: '#4c1d95' }}>{marginVal}</div>
                <div className="oc-trend-text" style={{ color: '#5b21b6' }}>Net Profit / Revenue</div>
              </div>
            </div>

            {/* Charts Row */}
            {(() => {
              const expenseBreakdownChart = {
                series: [poVal + generalVal, salaryVal],
                options: {
                  chart: { type: 'donut', height: 260 },
                  labels: ['Payment Expenses', 'Salary Tickets'],
                  colors: ['#ea580c', '#7c3aed'],
                  dataLabels: { enabled: false },
                  legend: { position: 'bottom', fontFamily: 'Inter, sans-serif' },
                  tooltip: { y: { formatter: (val) => `₹ ${val.toLocaleString('en-IN')}` } },
                  plotOptions: {
                    pie: {
                      donut: {
                        size: '75%',
                        labels: {
                          show: true,
                          name: { show: true, fontSize: '12px', color: '#64748b', offsetY: -10 },
                          value: { show: true, fontSize: '14px', fontWeight: 700, color: '#0f172a', offsetY: 5, formatter: (val) => `₹ ${Number(val).toLocaleString('en-IN')}` },
                          total: { show: true, label: 'Total Expenses', formatter: () => `₹ ${expenseVal.toLocaleString('en-IN')}` }
                        }
                      }
                    }
                  }
                }
              };

              const plTrendChart = {
                series: [
                  { name: 'Revenue', data: monthlyStatementData.map(m => m.revenue) },
                  { name: 'Expenses', data: monthlyStatementData.map(m => m.totalExpense) },
                  { name: 'Net Profit', data: monthlyStatementData.map(m => m.netProfit) }
                ],
                options: {
                  chart: { type: 'area', height: 260, toolbar: { show: false } },
                  dataLabels: { enabled: false },
                  stroke: { curve: 'smooth', width: [3, 3, 2], dashArray: [0, 0, 4] },
                  colors: ['#2563eb', '#ef4444', '#10b981'],
                  fill: {
                    type: 'gradient',
                    gradient: {
                      shadeIntensity: 1,
                      opacityFrom: [0.25, 0.25, 0.1],
                      opacityTo: [0.02, 0.02, 0.0],
                      stops: [0, 90, 100]
                    }
                  },
                  xaxis: {
                    categories: monthlyStatementData.map(m => m.shortMonth),
                    labels: { style: { fontFamily: 'Inter, sans-serif', fontWeight: 600 } }
                  },
                  yaxis: {
                    labels: { formatter: (val) => formatChartCurrency(val) }
                  },
                  legend: { position: 'top', fontFamily: 'Inter, sans-serif' },
                  tooltip: { y: { formatter: (val) => `₹ ${(val || 0).toLocaleString('en-IN')}` } }
                }
              };

              return (
                <div style={{ display: 'grid', gridTemplateColumns: '1.6fr 1fr', gap: '20px', marginBottom: '24px' }}>
                  <div className="oc-card" style={{ minHeight: '300px' }}>
                    <div className="oc-section-header" style={{ marginBottom: '12px' }}>Monthly Revenue, Expense & Profit Trend</div>
                    <Chart options={plTrendChart.options} series={plTrendChart.series} type="area" height={260} />
                  </div>

                  <div className="oc-card" style={{ minHeight: '300px' }}>
                    <div className="oc-section-header" style={{ marginBottom: '12px' }}>Expense Structure</div>
                    {expenseVal > 0 ? (
                      <Chart options={expenseBreakdownChart.options} series={expenseBreakdownChart.series} type="donut" height={260} />
                    ) : (
                      <div style={{ height: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#64748b', fontSize: '13px' }}>
                        No expense data recorded for this period.
                      </div>
                    )}
                  </div>
                </div>
              );
            })()}

            {/* Sub-view Navigation Tabs & Actions Bar */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', flexWrap: 'wrap', gap: '12px' }}>
              <div className="oc-sub-nav">
                <button
                  className={`oc-sub-tab ${plSubTab === 'sites' ? 'active' : ''}`}
                  onClick={() => setPlSubTab('sites')}
                >
                  <span>🏢 Site-wise Breakdown</span>
                  <span className="oc-sub-badge">{filteredSites.length} Sites</span>
                </button>
                <button
                  className={`oc-sub-tab ${plSubTab === 'months' ? 'active' : ''}`}
                  onClick={() => setPlSubTab('months')}
                >
                  <span>📅 Month-wise Statement</span>
                  <span className="oc-sub-badge">12 Months</span>
                </button>
                <button
                  className={`oc-sub-tab ${plSubTab === 'ledger' ? 'active' : ''}`}
                  onClick={() => setPlSubTab('ledger')}
                >
                  <span>📑 Transaction Ledger</span>
                  <span className="oc-sub-badge">{filteredLedger.length}</span>
                </button>
              </div>

              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <button
                  onClick={() => handleExportProfitLoss(plSubTab)}
                  style={{
                    padding: '7px 14px',
                    borderRadius: '8px',
                    background: '#16a34a',
                    color: '#fff',
                    border: 'none',
                    fontSize: '12px',
                    fontWeight: 600,
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    boxShadow: '0 2px 6px rgba(22, 163, 74, 0.25)'
                  }}
                  title="Export active table to Excel"
                >
                  <span>📥</span> Export Excel
                </button>
                <button
                  onClick={() => handleExportProfitLoss('all')}
                  style={{
                    padding: '7px 14px',
                    borderRadius: '8px',
                    background: '#0f172a',
                    color: '#fff',
                    border: 'none',
                    fontSize: '12px',
                    fontWeight: 600,
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    boxShadow: '0 2px 6px rgba(15, 23, 42, 0.25)'
                  }}
                  title="Download full multi-sheet workbook"
                >
                  <span>📑</span> Full Report Pack
                </button>
                <button
                  onClick={() => setGstDrawerOpen(true)}
                  style={{
                    padding: '7px 14px',
                    borderRadius: '8px',
                    background: '#1e3a8a',
                    color: '#fff',
                    border: 'none',
                    fontSize: '12px',
                    fontWeight: 600,
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    boxShadow: '0 2px 6px rgba(30, 58, 138, 0.25)'
                  }}
                >
                  <span>%</span> GST Summary
                </button>
              </div>
            </div>

            {/* TAB 1: SITE-WISE BREAKDOWN TABLE */}
            {plSubTab === 'sites' && (
              <div className="oc-card">
                <div className="oc-section-header" style={{ justifyContent: 'space-between', marginBottom: '16px', flexWrap: 'wrap', gap: '10px' }}>
                  <div>
                    <span style={{ fontSize: '16px', fontWeight: 700 }}>Site-wise Profit & Loss Performance</span>
                    <div style={{ fontSize: '11px', color: '#64748b', marginTop: '2px', fontWeight: 500 }}>
                      Financial performance comparison by site for {plMonthFilter === 'all' ? `Full FY ${filters.financialYear}` : monthNamesFull[plMonthFilter]}. Click ▶ to expand 12-month drilldown.
                    </div>
                  </div>

                  <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <button
                      onClick={toggleExpandAll}
                      style={{
                        padding: '6px 12px',
                        borderRadius: '6px',
                        border: '1px solid #cbd5e1',
                        background: '#f8fafc',
                        color: '#334155',
                        fontSize: '12px',
                        fontWeight: 600,
                        cursor: 'pointer'
                      }}
                    >
                      {expandedSiteIds.length === currentSites.length && currentSites.length > 0 ? 'Collapse All' : 'Expand All'}
                    </button>
                    <input
                      type="text"
                      placeholder="Search site or company..."
                      value={plSiteSearch}
                      onChange={e => { setPlSiteSearch(e.target.value); setPlSitePage(1); }}
                      style={{ padding: '6px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '12px', outline: 'none', width: '220px' }}
                    />
                  </div>
                </div>

                <div style={{ overflowX: 'auto' }}>
                  <table className="oc-table" style={{ fontSize: '13px', width: '100%' }}>
                    <thead>
                      <tr>
                        <th style={{ width: '40px', textAlign: 'center' }}>#</th>
                        <th>Site Name & Company</th>
                        <th style={{ textAlign: 'right' }}>Revenue (₹)</th>
                        <th style={{ textAlign: 'right' }}>Salary Exp (₹)</th>
                        <th style={{ textAlign: 'right' }}>Payment Exp (₹)</th>
                        <th style={{ textAlign: 'right' }}>Total Exp (₹)</th>
                        <th style={{ textAlign: 'right' }}>Net Profit / (Loss) (₹)</th>
                        <th style={{ textAlign: 'center' }}>Margin</th>
                        <th style={{ textAlign: 'center' }}>Health</th>
                        <th style={{ textAlign: 'center' }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentSites.length > 0 ? currentSites.map((site, idx) => {
                        const sKey = site.siteId || site.siteName;
                        const isExpanded = expandedSiteIds.includes(sKey);
                        const isProfitable = site.filteredNetProfit >= 0;

                        return (
                          <React.Fragment key={idx}>
                            <tr className="oc-table-row-hover" style={{ background: isExpanded ? '#f8fafc' : 'transparent' }}>
                              <td style={{ textAlign: 'center' }}>
                                <button
                                  className={`oc-expand-btn ${isExpanded ? 'active' : ''}`}
                                  onClick={() => toggleSiteExpand(sKey)}
                                  title={isExpanded ? 'Collapse monthly breakdown' : 'Expand monthly breakdown'}
                                >
                                  {isExpanded ? '▼' : '▶'}
                                </button>
                              </td>
                              <td>
                                <div style={{ fontWeight: 700, color: '#0f172a', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                  <span>{site.siteName}</span>
                                </div>
                                <div style={{ fontSize: '11px', color: '#64748b' }}>{site.companyName}</div>
                              </td>
                              <td style={{ textAlign: 'right', fontWeight: 700, color: '#1e3a8a' }}>
                                {site.filteredRevenue > 0 ? `₹ ${site.filteredRevenue.toLocaleString('en-IN')}` : '--'}
                              </td>
                              <td style={{ textAlign: 'right', fontWeight: 600, color: '#a21caf' }}>
                                {site.filteredSalaryExpense > 0 ? `₹ ${site.filteredSalaryExpense.toLocaleString('en-IN')}` : '--'}
                              </td>
                              <td style={{ textAlign: 'right', fontWeight: 600, color: '#c2410c' }}>
                                {site.filteredPaymentExpense > 0 ? `₹ ${site.filteredPaymentExpense.toLocaleString('en-IN')}` : '--'}
                              </td>
                              <td style={{ textAlign: 'right', fontWeight: 700, color: '#475569' }}>
                                {site.filteredTotalExpense > 0 ? `₹ ${site.filteredTotalExpense.toLocaleString('en-IN')}` : '--'}
                              </td>
                              <td style={{
                                textAlign: 'right',
                                fontWeight: 800,
                                color: isProfitable ? '#16a34a' : '#dc2626'
                              }}>
                                {isProfitable ? '+' : ''}₹ {site.filteredNetProfit.toLocaleString('en-IN')}
                              </td>
                              <td style={{ textAlign: 'center', fontWeight: 700, color: isProfitable ? '#15803d' : '#b91c1c' }}>
                                {site.filteredMargin}
                              </td>
                              <td style={{ textAlign: 'center' }}>
                                <span className={`oc-profit-pill ${site.filteredRevenue === 0 && site.filteredTotalExpense === 0 ? 'neutral' : isProfitable ? 'positive' : 'negative'}`}>
                                  {site.filteredRevenue === 0 && site.filteredTotalExpense === 0 ? 'No Activity' : isProfitable ? 'Profitable' : 'Deficit'}
                                </span>
                              </td>
                              <td style={{ textAlign: 'center' }}>
                                {site.siteId && (
                                  <button
                                    onClick={() => openSiteDrawer({ id: site.siteId, name: site.siteName })}
                                    style={{
                                      padding: '4px 8px',
                                      borderRadius: '6px',
                                      border: '1px solid #cbd5e1',
                                      background: '#fff',
                                      fontSize: '11px',
                                      fontWeight: 600,
                                      color: '#2563eb',
                                      cursor: 'pointer'
                                    }}
                                    title="Open full site analytics drawer"
                                  >
                                    Drilldown
                                  </button>
                                )}
                              </td>
                            </tr>

                            {/* Nested 12-Month Accordion Breakdown */}
                            {isExpanded && (
                              <tr>
                                <td colSpan="10" style={{ padding: '0 16px 16px 16px', background: '#f8fafc' }}>
                                  <div className="oc-nested-table-container">
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                      <div style={{ fontSize: '13px', fontWeight: 700, color: '#1e293b' }}>
                                        📅 12-Month Financial Breakdown — <span style={{ color: '#2563eb' }}>{site.siteName}</span> ({filters.financialYear})
                                      </div>
                                      <div style={{ fontSize: '11px', color: '#64748b' }}>
                                        Full Year Net Profit: <strong style={{ color: site.totalNetProfit >= 0 ? '#16a34a' : '#dc2626' }}>₹ {site.totalNetProfit.toLocaleString('en-IN')}</strong> (Margin: {site.totalMargin})
                                      </div>
                                    </div>
                                    <table className="oc-nested-table">
                                      <thead>
                                        <tr>
                                          <th>Month</th>
                                          <th style={{ textAlign: 'right' }}>Revenue (Invoiced)</th>
                                          <th style={{ textAlign: 'right' }}>Salary Expenses</th>
                                          <th style={{ textAlign: 'right' }}>PO Expenses</th>
                                          <th style={{ textAlign: 'right' }}>General Payments</th>
                                          <th style={{ textAlign: 'right' }}>Total Payment Exp</th>
                                          <th style={{ textAlign: 'right' }}>Total Expenses</th>
                                          <th style={{ textAlign: 'right' }}>Net Profit / Loss</th>
                                          <th style={{ textAlign: 'center' }}>Margin</th>
                                          <th style={{ textAlign: 'center' }}>Status</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {monthsOrder.map((mKey, mIdx) => {
                                          const mData = site.months[mKey];
                                          const mProfitable = mData.netProfit >= 0;
                                          const hasActivity = mData.revenue > 0 || mData.totalExpense > 0;

                                          return (
                                            <tr key={mIdx} style={{ background: plMonthFilter === mKey ? '#eff6ff' : 'transparent' }}>
                                              <td style={{ fontWeight: 700, color: plMonthFilter === mKey ? '#1d4ed8' : '#334155' }}>
                                                {mData.monthName} {plMonthFilter === mKey && '⭐'}
                                              </td>
                                              <td style={{ textAlign: 'right', fontWeight: mData.revenue > 0 ? 700 : 500, color: mData.revenue > 0 ? '#1e3a8a' : '#94a3b8' }}>
                                                {mData.revenue > 0 ? `₹ ${mData.revenue.toLocaleString('en-IN')}` : '--'}
                                              </td>
                                              <td style={{ textAlign: 'right', color: mData.salaryExpense > 0 ? '#a21caf' : '#94a3b8' }}>
                                                {mData.salaryExpense > 0 ? `₹ ${mData.salaryExpense.toLocaleString('en-IN')}` : '--'}
                                              </td>
                                              <td style={{ textAlign: 'right', color: mData.poExpense > 0 ? '#ea580c' : '#94a3b8' }}>
                                                {mData.poExpense > 0 ? `₹ ${mData.poExpense.toLocaleString('en-IN')}` : '--'}
                                              </td>
                                              <td style={{ textAlign: 'right', color: mData.generalExpense > 0 ? '#c2410c' : '#94a3b8' }}>
                                                {mData.generalExpense > 0 ? `₹ ${mData.generalExpense.toLocaleString('en-IN')}` : '--'}
                                              </td>
                                              <td style={{ textAlign: 'right', fontWeight: 600, color: mData.paymentExpense > 0 ? '#c2410c' : '#94a3b8' }}>
                                                {mData.paymentExpense > 0 ? `₹ ${mData.paymentExpense.toLocaleString('en-IN')}` : '--'}
                                              </td>
                                              <td style={{ textAlign: 'right', fontWeight: 700, color: mData.totalExpense > 0 ? '#475569' : '#94a3b8' }}>
                                                {mData.totalExpense > 0 ? `₹ ${mData.totalExpense.toLocaleString('en-IN')}` : '--'}
                                              </td>
                                              <td style={{ textAlign: 'right', fontWeight: 800, color: hasActivity ? (mProfitable ? '#16a34a' : '#dc2626') : '#94a3b8' }}>
                                                {hasActivity ? `${mProfitable ? '+' : ''}₹ ${mData.netProfit.toLocaleString('en-IN')}` : '--'}
                                              </td>
                                              <td style={{ textAlign: 'center', fontWeight: 600, color: hasActivity ? (mProfitable ? '#15803d' : '#b91c1c') : '#94a3b8' }}>
                                                {hasActivity ? mData.margin : '--'}
                                              </td>
                                              <td style={{ textAlign: 'center' }}>
                                                {hasActivity ? (
                                                  <span className={`oc-profit-pill ${mProfitable ? 'positive' : 'negative'}`} style={{ fontSize: '10px', padding: '2px 6px' }}>
                                                    {mProfitable ? 'Profit' : 'Loss'}
                                                  </span>
                                                ) : (
                                                  <span style={{ color: '#94a3b8', fontSize: '11px' }}>--</span>
                                                )}
                                              </td>
                                            </tr>
                                          );
                                        })}
                                        {/* Site 12-Month Total Row */}
                                        <tr className="oc-table-total-row">
                                          <td>TOTAL YTD</td>
                                          <td style={{ textAlign: 'right', color: '#1e3a8a' }}>₹ {site.totalRevenue.toLocaleString('en-IN')}</td>
                                          <td style={{ textAlign: 'right', color: '#a21caf' }}>₹ {site.totalSalaryExpense.toLocaleString('en-IN')}</td>
                                          <td style={{ textAlign: 'right', color: '#ea580c' }}>₹ {site.totalPoExpense.toLocaleString('en-IN')}</td>
                                          <td style={{ textAlign: 'right', color: '#c2410c' }}>₹ {site.totalGeneralExpense.toLocaleString('en-IN')}</td>
                                          <td style={{ textAlign: 'right', color: '#c2410c' }}>₹ {site.totalPaymentExpense.toLocaleString('en-IN')}</td>
                                          <td style={{ textAlign: 'right', color: '#475569' }}>₹ {site.totalExpense.toLocaleString('en-IN')}</td>
                                          <td style={{ textAlign: 'right', color: site.totalNetProfit >= 0 ? '#16a34a' : '#dc2626' }}>
                                            {site.totalNetProfit >= 0 ? '+' : ''}₹ {site.totalNetProfit.toLocaleString('en-IN')}
                                          </td>
                                          <td style={{ textAlign: 'center' }}>{site.totalMargin}</td>
                                          <td style={{ textAlign: 'center' }}>
                                            <span className={`oc-profit-pill ${site.totalNetProfit >= 0 ? 'positive' : 'negative'}`} style={{ fontSize: '10px', padding: '2px 6px' }}>
                                              {site.totalNetProfit >= 0 ? 'Profitable' : 'Deficit'}
                                            </span>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        );
                      }) : (
                        <tr>
                          <td colSpan="10" style={{ textAlign: 'center', color: '#64748b', padding: '30px' }}>
                            No sites match your search criteria.
                          </td>
                        </tr>
                      )}

                      {/* Filtered Summary Row */}
                      {filteredSites.length > 0 && (
                        <tr className="oc-table-total-row">
                          <td style={{ textAlign: 'center' }}>Σ</td>
                          <td>
                            <div>SUBTOTAL ({filteredSites.length} Sites)</div>
                            <div style={{ fontSize: '11px', color: '#64748b', fontWeight: 500 }}>
                              {plMonthFilter === 'all' ? `Full FY ${filters.financialYear}` : monthNamesFull[plMonthFilter]}
                            </div>
                          </td>
                          <td style={{ textAlign: 'right', color: '#1e3a8a' }}>₹ {filteredSites.reduce((s, i) => s + i.filteredRevenue, 0).toLocaleString('en-IN')}</td>
                          <td style={{ textAlign: 'right', color: '#a21caf' }}>₹ {filteredSites.reduce((s, i) => s + i.filteredSalaryExpense, 0).toLocaleString('en-IN')}</td>
                          <td style={{ textAlign: 'right', color: '#c2410c' }}>₹ {filteredSites.reduce((s, i) => s + i.filteredPaymentExpense, 0).toLocaleString('en-IN')}</td>
                          <td style={{ textAlign: 'right', color: '#475569' }}>₹ {filteredSites.reduce((s, i) => s + i.filteredTotalExpense, 0).toLocaleString('en-IN')}</td>
                          {(() => {
                            const subRev = filteredSites.reduce((s, i) => s + i.filteredRevenue, 0);
                            const subExp = filteredSites.reduce((s, i) => s + i.filteredTotalExpense, 0);
                            const subNet = subRev - subExp;
                            const subMargin = subRev > 0 ? ((subNet / subRev) * 100).toFixed(1) + '%' : '0%';
                            return (
                              <>
                                <td style={{ textAlign: 'right', color: subNet >= 0 ? '#16a34a' : '#dc2626' }}>
                                  {subNet >= 0 ? '+' : ''}₹ {subNet.toLocaleString('en-IN')}
                                </td>
                                <td style={{ textAlign: 'center', color: subNet >= 0 ? '#15803d' : '#b91c1c' }}>{subMargin}</td>
                                <td style={{ textAlign: 'center' }}>
                                  <span className={`oc-profit-pill ${subNet >= 0 ? 'positive' : 'negative'}`}>
                                    {subNet >= 0 ? 'Profitable' : 'Deficit'}
                                  </span>
                                </td>
                                <td></td>
                              </>
                            );
                          })()}
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Site-wise Pagination Controls */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '16px', paddingTop: '16px', borderTop: '1px solid #f1f5f9', flexWrap: 'wrap', gap: '10px' }}>
                  <div style={{ fontSize: '12px', color: '#64748b', fontWeight: 500 }}>
                    {filteredSites.length > 0 ? (
                      `Showing ${(plSitePage - 1) * plSiteLimit + 1} to ${Math.min(plSitePage * plSiteLimit, filteredSites.length)} of ${filteredSites.length} sites`
                    ) : (
                      `Showing 0 to 0 of 0 sites`
                    )}
                  </div>
                  <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px' }}>
                      <span style={{ color: '#64748b' }}>Show:</span>
                      <select
                        value={plSiteLimit}
                        onChange={e => {
                          setPlSiteLimit(Number(e.target.value));
                          setPlSitePage(1);
                        }}
                        style={{
                          padding: '4px 8px',
                          borderRadius: '6px',
                          border: '1px solid #cbd5e1',
                          background: '#fff',
                          fontSize: '12px',
                          fontWeight: 600,
                          color: '#334155',
                          outline: 'none',
                          cursor: 'pointer'
                        }}
                      >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                    </div>
                    <div style={{ display: 'flex', gap: '4px', alignItems: 'center', fontSize: '12px' }}>
                      <button onClick={() => setPlSitePage(1)} disabled={plSitePage === 1} style={{ padding: '4px 10px', borderRadius: '6px', border: '1px solid #cbd5e1', background: '#fff', cursor: 'pointer', fontWeight: 'bold' }} title="First Page">&lt;&lt;</button>
                      <button onClick={() => setPlSitePage(p => Math.max(1, p - 1))} disabled={plSitePage === 1} style={{ padding: '4px 10px', borderRadius: '6px', border: '1px solid #cbd5e1', background: '#fff', cursor: 'pointer' }} title="Previous Page">&lt;</button>
                      <span style={{ color: '#64748b', fontWeight: 600, margin: '0 8px' }}>Page {plSitePage} of {siteTotalPages}</span>
                      <button onClick={() => setPlSitePage(p => Math.min(siteTotalPages, p + 1))} disabled={plSitePage === siteTotalPages} style={{ padding: '4px 10px', borderRadius: '6px', border: '1px solid #cbd5e1', background: '#fff', cursor: 'pointer' }} title="Next Page">&gt;</button>
                      <button onClick={() => setPlSitePage(siteTotalPages)} disabled={plSitePage === siteTotalPages} style={{ padding: '4px 10px', borderRadius: '6px', border: '1px solid #cbd5e1', background: '#fff', cursor: 'pointer', fontWeight: 'bold' }} title="Last Page">&gt;&gt;</button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* TAB 2: MONTH-WISE 12 MONTH STATEMENT TABLE */}
            {plSubTab === 'months' && (
              <div className="oc-card">
                <div className="oc-section-header" style={{ justifyContent: 'space-between', marginBottom: '16px', flexWrap: 'wrap', gap: '10px' }}>
                  <div>
                    <span style={{ fontSize: '16px', fontWeight: 700 }}>12-Month Financial Statement (P&L Ledger)</span>
                    <div style={{ fontSize: '11px', color: '#64748b', marginTop: '2px', fontWeight: 500 }}>
                      Complete month-by-month accounting timeline for Financial Year {filters.financialYear}
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                    <button
                      onClick={() => handleExportProfitLoss('months')}
                      style={{ padding: '6px 12px', borderRadius: '6px', background: '#16a34a', color: '#fff', border: 'none', fontSize: '12px', fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' }}
                    >
                      <span>📥</span> Export Statement
                    </button>
                  </div>
                </div>

                <div style={{ overflowX: 'auto' }}>
                  <table className="oc-table" style={{ fontSize: '13px', width: '100%' }}>
                    <thead>
                      <tr>
                        <th>Financial Month</th>
                        <th style={{ textAlign: 'right' }}>Revenue (Invoiced ₹)</th>
                        <th style={{ textAlign: 'right' }}>Salary Expenses (₹)</th>
                        <th style={{ textAlign: 'right' }}>PO Payments (₹)</th>
                        <th style={{ textAlign: 'right' }}>General Payments (₹)</th>
                        <th style={{ textAlign: 'right' }}>Total Payment Exp (₹)</th>
                        <th style={{ textAlign: 'right' }}>Total Expenses (₹)</th>
                        <th style={{ textAlign: 'right' }}>Net Profit / (Loss) (₹)</th>
                        <th style={{ textAlign: 'center' }}>Margin (%)</th>
                        <th style={{ textAlign: 'center' }}>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {monthlyStatementData.map((m, idx) => {
                        const isProfitable = m.netProfit >= 0;
                        const hasActivity = m.revenue > 0 || m.totalExpense > 0;

                        return (
                          <tr
                            key={idx}
                            className="oc-table-row-hover"
                            style={{ background: plMonthFilter === m.shortMonth ? '#eff6ff' : 'transparent', cursor: 'pointer' }}
                            onClick={() => {
                              setPlMonthFilter(m.shortMonth);
                              setPlSubTab('sites');
                            }}
                            title={`Click to view site-wise breakdown for ${m.monthName}`}
                          >
                            <td>
                              <div style={{ fontWeight: 700, color: '#0f172a' }}>
                                {m.monthName} {plMonthFilter === m.shortMonth && '⭐'}
                              </div>
                              <div style={{ fontSize: '11px', color: '#64748b' }}>FY {filters.financialYear}</div>
                            </td>
                            <td style={{ textAlign: 'right', fontWeight: 700, color: '#1e3a8a' }}>
                              {m.revenue > 0 ? `₹ ${m.revenue.toLocaleString('en-IN')}` : '--'}
                            </td>
                            <td style={{ textAlign: 'right', fontWeight: 600, color: '#a21caf' }}>
                              {m.salaryExpense > 0 ? `₹ ${m.salaryExpense.toLocaleString('en-IN')}` : '--'}
                            </td>
                            <td style={{ textAlign: 'right', color: '#ea580c' }}>
                              {m.poExpense > 0 ? `₹ ${m.poExpense.toLocaleString('en-IN')}` : '--'}
                            </td>
                            <td style={{ textAlign: 'right', color: '#c2410c' }}>
                              {m.generalExpense > 0 ? `₹ ${m.generalExpense.toLocaleString('en-IN')}` : '--'}
                            </td>
                            <td style={{ textAlign: 'right', fontWeight: 600, color: '#c2410c' }}>
                              {m.paymentExpense > 0 ? `₹ ${m.paymentExpense.toLocaleString('en-IN')}` : '--'}
                            </td>
                            <td style={{ textAlign: 'right', fontWeight: 700, color: '#475569' }}>
                              {m.totalExpense > 0 ? `₹ ${m.totalExpense.toLocaleString('en-IN')}` : '--'}
                            </td>
                            <td style={{
                              textAlign: 'right',
                              fontWeight: 800,
                              color: hasActivity ? (isProfitable ? '#16a34a' : '#dc2626') : '#94a3b8'
                            }}>
                              {hasActivity ? `${isProfitable ? '+' : ''}₹ ${m.netProfit.toLocaleString('en-IN')}` : '--'}
                            </td>
                            <td style={{ textAlign: 'center', fontWeight: 700, color: hasActivity ? (isProfitable ? '#15803d' : '#b91c1c') : '#94a3b8' }}>
                              {hasActivity ? m.margin : '--'}
                            </td>
                            <td style={{ textAlign: 'center' }}>
                              {hasActivity ? (
                                <span className={`oc-profit-pill ${isProfitable ? 'positive' : 'negative'}`}>
                                  {isProfitable ? 'Profitable' : 'Deficit'}
                                </span>
                              ) : (
                                <span style={{ color: '#94a3b8', fontSize: '12px' }}>No Activity</span>
                              )}
                            </td>
                          </tr>
                        );
                      })}

                      {/* Full Year Summary Total Row */}
                      <tr className="oc-table-total-row">
                        <td>
                          <div>TOTAL FINANCIAL YEAR (YTD)</div>
                          <div style={{ fontSize: '11px', color: '#64748b', fontWeight: 500 }}>Full 12 Months</div>
                        </td>
                        <td style={{ textAlign: 'right', color: '#1e3a8a', fontSize: '14px' }}>₹ {fullYearRevenue.toLocaleString('en-IN')}</td>
                        <td style={{ textAlign: 'right', color: '#a21caf' }}>₹ {fullYearSalary.toLocaleString('en-IN')}</td>
                        <td style={{ textAlign: 'right', color: '#ea580c' }}>₹ {fullYearPO.toLocaleString('en-IN')}</td>
                        <td style={{ textAlign: 'right', color: '#c2410c' }}>₹ {fullYearGen.toLocaleString('en-IN')}</td>
                        <td style={{ textAlign: 'right', color: '#c2410c' }}>₹ {fullYearPayment.toLocaleString('en-IN')}</td>
                        <td style={{ textAlign: 'right', color: '#475569', fontSize: '14px' }}>₹ {fullYearTotalExp.toLocaleString('en-IN')}</td>
                        <td style={{ textAlign: 'right', color: fullYearNetProfit >= 0 ? '#16a34a' : '#dc2626', fontSize: '15px' }}>
                          {fullYearNetProfit >= 0 ? '+' : ''}₹ {fullYearNetProfit.toLocaleString('en-IN')}
                        </td>
                        <td style={{ textAlign: 'center', color: fullYearNetProfit >= 0 ? '#15803d' : '#b91c1c', fontSize: '14px' }}>
                          {fullYearMargin}
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          <span className={`oc-profit-pill ${fullYearNetProfit >= 0 ? 'positive' : 'negative'}`} style={{ fontSize: '12px', padding: '4px 10px' }}>
                            {fullYearNetProfit >= 0 ? 'Profitable YTD' : 'Deficit YTD'}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {/* TAB 3: TRANSACTION GENERAL LEDGER */}
            {plSubTab === 'ledger' && (
              <div className="oc-card">
                <div className="oc-section-header" style={{ justifyContent: 'space-between', marginBottom: '16px', flexWrap: 'wrap', gap: '10px' }}>
                  <div>
                    <span style={{ fontSize: '16px', fontWeight: 700 }}>General Transaction Ledger</span>
                    <div style={{ fontSize: '11px', color: '#64748b', marginTop: '2px', fontWeight: 500 }}>
                      Chronological itemized records of revenue invoices, salary tickets, and payment vouchers
                    </div>
                  </div>

                  <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
                    <select
                      value={plTypeFilter}
                      onChange={e => { setPlTypeFilter(e.target.value); setProfitLossPage(1); }}
                      style={{ padding: '6px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '12px', outline: 'none', background: '#fff', fontWeight: 600, color: '#334155', cursor: 'pointer' }}
                    >
                      <option value="all">All Types</option>
                      <option value="Invoice">Invoices (Revenue)</option>
                      <option value="PO">PO Payments (Expense)</option>
                      <option value="Salary">Salary Tickets (Expense)</option>
                      <option value="Payment">General Payments (Expense)</option>
                    </select>
                    <input
                      type="text"
                      placeholder="Search ledger..."
                      value={profitLossSearch}
                      onChange={e => { setProfitLossSearch(e.target.value); setProfitLossPage(1); }}
                      style={{ padding: '6px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '12px', outline: 'none', width: '200px' }}
                    />
                  </div>
                </div>

                <div style={{ overflowX: 'auto' }}>
                  <table className="oc-table" style={{ fontSize: '13px', width: '100%' }}>
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Reference</th>
                        <th>Site / Party</th>
                        <th>Type</th>
                        <th style={{ textAlign: 'right' }}>Debit (Out ₹)</th>
                        <th style={{ textAlign: 'right' }}>Credit (In ₹)</th>
                        <th style={{ textAlign: 'center' }}>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentLedger.length > 0 ? currentLedger.map((item, idx) => (
                        <tr key={idx} className="oc-table-row-hover">
                          <td>{item.displayDate || item.date}</td>
                          <td
                            style={{ fontWeight: 600, color: '#2563eb', cursor: 'pointer' }}
                            onClick={() => {
                              if (item.id) {
                                let url = '';
                                if (item.type === 'Invoice') {
                                  url = `${window.location.origin}${RoutesLink.invoice_detail}/${item.id}`;
                                } else if (item.type === 'Payment' || item.type === 'PO') {
                                  if (item.ticketType === 'AgainstPO') {
                                    url = `${window.location.origin}${RoutesLink.payment_tickets_details}/againstPo/${item.id}`;
                                  } else if (item.ticketType === 'General') {
                                    url = `${window.location.origin}${RoutesLink.payment_tickets_details}/general/${item.id}`;
                                  } else if (item.ticketType === 'Reimbursement') {
                                    url = `${window.location.origin}${RoutesLink.payment_tickets_details}/Reimbursement/${item.id}`;
                                  }
                                } else if (item?.type === 'Salary') {
                                  url = `${window.location.origin}${RoutesLink.salary_ticket_detail}/${item.id}`;
                                }
                                if (url) window.open(url, '_blank');
                              }
                            }}
                          >
                            {item.reference}
                          </td>
                          <td>
                            <div style={{ fontWeight: 600, color: '#0f172a' }}>{item.siteName && item.siteName !== 'N/A' ? item.siteName : item.party}</div>
                            {item.siteName && item.party && item.party !== item.siteName && item.party !== 'N/A' && (
                              <div style={{ fontSize: '11px', color: '#64748b' }}>{item.party}</div>
                            )}
                          </td>
                          <td>
                            {(() => {
                              const typeLower = (item.type || '').toLowerCase();
                              let bg = '#f1f5f9';
                              let fg = '#475569';

                              if (typeLower === 'invoice') {
                                bg = '#eff6ff';
                                fg = '#1d4ed8';
                              } else if (typeLower === 'salary') {
                                bg = '#f5f3ff';
                                fg = '#6d28d9';
                              } else if (typeLower.includes('po') || typeLower.includes('purchase')) {
                                bg = '#fff7ed';
                                fg = '#c2410c';
                              } else if (typeLower === 'payment') {
                                bg = '#f0fdf4';
                                fg = '#15803d';
                              }

                              return (
                                <span style={{
                                  background: bg,
                                  color: fg,
                                  padding: '4px 8px',
                                  borderRadius: '6px',
                                  fontWeight: 700,
                                  fontSize: '11px',
                                  display: 'inline-block'
                                }}>
                                  {item.type} {item.ticketType ? `(${item.ticketType})` : ''}
                                </span>
                              );
                            })()}
                          </td>
                          <td style={{ textAlign: 'right', color: item.debit > 0 ? '#dc2626' : '#64748b', fontWeight: item.debit > 0 ? 700 : 500 }}>
                            {item.debit > 0 ? `₹ ${item.debit.toLocaleString('en-IN')}` : '--'}
                          </td>
                          <td style={{ textAlign: 'right', color: item.credit > 0 ? '#10b981' : '#64748b', fontWeight: item.credit > 0 ? 700 : 500 }}>
                            {item.credit > 0 ? `₹ ${item.credit.toLocaleString('en-IN')}` : '--'}
                          </td>
                          <td style={{ textAlign: 'center' }}>
                            {(() => {
                              const statusLower = (item.status || '').toLowerCase();
                              let bg = '#f1f5f9';
                              let fg = '#475569';

                              if (statusLower.includes('approved') || statusLower.includes('completed') || statusLower === 'received') {
                                bg = '#dcfce7';
                                fg = '#15803d';
                              } else if (statusLower.includes('pending') || statusLower.includes('created')) {
                                bg = '#fef9c3';
                                fg = '#a16207';
                              } else if (statusLower.includes('rejected') || statusLower === 'unpaid') {
                                bg = '#fee2e2';
                                fg = '#b91c1c';
                              }

                              return (
                                <span className="oc-status-badge" style={{ background: bg, color: fg }}>
                                  {item.status}
                                </span>
                              );
                            })()}
                          </td>
                        </tr>
                      )) : (
                        <tr>
                          <td colSpan="7" style={{ textAlign: 'center', color: '#64748b', padding: '30px' }}>
                            No ledger entries found matching your search.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Bottom Pagination & Limit Selector Controls */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '16px', paddingTop: '16px', borderTop: '1px solid #f1f5f9', flexWrap: 'wrap', gap: '10px' }}>
                  <div style={{ fontSize: '12px', color: '#64748b', fontWeight: 500 }}>
                    {filteredLedger.length > 0 ? (
                      `Showing ${(profitLossPage - 1) * profitLossLimit + 1} to ${Math.min(profitLossPage * profitLossLimit, filteredLedger.length)} of ${filteredLedger.length} entries`
                    ) : (
                      `Showing 0 to 0 of 0 entries`
                    )}
                  </div>
                  <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px' }}>
                      <span style={{ color: '#64748b' }}>Show Limit:</span>
                      <select
                        value={profitLossLimit}
                        onChange={e => {
                          setProfitLossLimit(Number(e.target.value));
                          setProfitLossPage(1);
                        }}
                        style={{
                          padding: '4px 8px',
                          borderRadius: '6px',
                          border: '1px solid #cbd5e1',
                          background: '#fff',
                          fontSize: '12px',
                          fontWeight: 600,
                          color: '#334155',
                          outline: 'none',
                          cursor: 'pointer'
                        }}
                      >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                    </div>
                    <div style={{ display: 'flex', gap: '4px', alignItems: 'center', fontSize: '12px' }}>
                      <button onClick={() => setProfitLossPage(1)} disabled={profitLossPage === 1} style={{ padding: '4px 10px', borderRadius: '6px', border: '1px solid #cbd5e1', background: '#fff', cursor: 'pointer', fontWeight: 'bold' }} title="First Page">&lt;&lt;</button>
                      <button onClick={() => setProfitLossPage(p => Math.max(1, p - 1))} disabled={profitLossPage === 1} style={{ padding: '4px 10px', borderRadius: '6px', border: '1px solid #cbd5e1', background: '#fff', cursor: 'pointer' }} title="Previous Page">&lt;</button>
                      <span style={{ color: '#64748b', fontWeight: 600, margin: '0 8px' }}>Page {profitLossPage} of {totalLedgerPages}</span>
                      <button onClick={() => setProfitLossPage(p => Math.min(totalLedgerPages, p + 1))} disabled={profitLossPage === totalLedgerPages} style={{ padding: '4px 10px', borderRadius: '6px', border: '1px solid #cbd5e1', background: '#fff', cursor: 'pointer' }} title="Next Page">&gt;</button>
                      <button onClick={() => setProfitLossPage(totalLedgerPages)} disabled={profitLossPage === totalLedgerPages} style={{ padding: '4px 10px', borderRadius: '6px', border: '1px solid #cbd5e1', background: '#fff', cursor: 'pointer', fontWeight: 'bold' }} title="Last Page">&gt;&gt;</button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        );
      })()}

      {/* ZONE 5: Salary Spends Analytics */}
      {activeZone === 'salary' && salaryData && (() => {
        const monthsListOptions = [
          { value: 'all', label: 'All Months' },
          { value: '04', label: 'April' },
          { value: '05', label: 'May' },
          { value: '06', label: 'June' },
          { value: '07', label: 'July' },
          { value: '08', label: 'August' },
          { value: '09', label: 'September' },
          { value: '10', label: 'October' },
          { value: '11', label: 'November' },
          { value: '12', label: 'December' },
          { value: '01', label: 'January' },
          { value: '02', label: 'February' },
          { value: '03', label: 'March' }
        ];

        let requestedSalary = 0;
        let approvedSalary = 0;
        let paidSalary = 0;
        let pendingSalary = 0;
        let pfEmployer = 0;
        let pfEmployee = 0;
        let esicEmployer = 0;
        let esicEmployee = 0;

        // Filter tickets and sum KPIs
        const filteredTickets = (salaryData.tickets || []).filter(t => {
          if (salaryMonthFilter === 'all') return true;
          return t.month.startsWith(salaryMonthFilter + '/');
        });

        filteredTickets.forEach(t => {
          const amt = parseFloat(t.totalAmount || 0);
          requestedSalary += amt;
          const status = (t.status || '').toLowerCase();
          if (status.includes('paid') || status.includes('completed') || status.includes('payment completed')) {
            paidSalary += amt;
          } else if (status.includes('approve')) {
            approvedSalary += amt;
          } else {
            pendingSalary += amt;
          }
        });

        // Filter monthlySummary and sum PF/ESIC
        const filteredSummary = (salaryData.monthlySummary || []).filter(m => {
          if (salaryMonthFilter === 'all') return true;
          return m.monthKey.startsWith(salaryMonthFilter + '/');
        });

        filteredSummary.forEach(m => {
          pfEmployer += m.pfEmployer;
          pfEmployee += m.pfEmployee;
          esicEmployer += m.esicEmployer;
          esicEmployee += m.esicEmployee;
        });

        const localKpis = salaryMonthFilter === 'all' && salaryData.kpis && salaryData.kpis.length > 0
          ? salaryData.kpis
          : [
            { title: "Total Requested Salary", value: formatChartCurrency(requestedSalary), description: "Total salary ticket budget", icon: "💰" },
            { title: "Approved Salary", value: formatChartCurrency(approvedSalary), description: "Director / Finance approved", icon: "✍️" },
            { title: "Paid Salary", value: formatChartCurrency(paidSalary), description: "Tickets fully disbursed", icon: "✅" },
            { title: "Pending Salary", value: formatChartCurrency(pendingSalary), description: "Tickets awaiting approval", icon: "⏳" },
            { title: "PF (Employer)", value: formatChartCurrency(pfEmployer), description: "Employer PF Contribution", icon: "🏢" },
            { title: "PF (Employee)", value: formatChartCurrency(pfEmployee), description: "Employee PF Deduction", icon: "👤" },
            { title: "ESIC (Employer)", value: formatChartCurrency(esicEmployer), description: "Employer ESIC Contribution", icon: "🏢" },
            { title: "ESIC (Employee)", value: formatChartCurrency(esicEmployee), description: "Employee ESIC Deduction", icon: "👤" }
          ];

        // Group status distribution dynamically
        const statusMap = {};
        filteredTickets.forEach(t => {
          const status = t.status || 'Pending';
          const amt = parseFloat(t.totalAmount || 0);
          if (!statusMap[status]) statusMap[status] = 0;
          statusMap[status] += amt;
        });
        const statusSeries = salaryMonthFilter === 'all' && salaryData.statusDistribution
          ? salaryData.statusDistribution.map(d => d.amount)
          : Object.values(statusMap);
        const statusLabels = salaryMonthFilter === 'all' && salaryData.statusDistribution
          ? salaryData.statusDistribution.map(d => d.name)
          : Object.keys(statusMap);

        // Group site distribution dynamically
        const siteMap = {};
        filteredTickets.forEach(t => {
          const siteName = t.siteName || 'Unassigned';
          const amt = parseFloat(t.totalAmount || 0);
          if (!siteMap[siteName]) siteMap[siteName] = 0;
          siteMap[siteName] += amt;
        });
        const sortedSites = salaryMonthFilter === 'all' && salaryData.siteDistribution
          ? salaryData.siteDistribution
          : Object.keys(siteMap).map(name => ({
            name,
            amount: siteMap[name]
          })).sort((a, b) => b.amount - a.amount).slice(0, 10);

        return (
          <>
            {/* Header and Dropdown month filter */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <div>
                <h3 style={{ fontSize: '18px', fontWeight: 700, color: '#0f172a', margin: 0 }}>Salary & Compliance Overview</h3>
                <div style={{ fontSize: '12px', color: '#64748b', marginTop: '2px' }}>Track salary tickets and statutory contributions</div>
              </div>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <select
                  value={salaryMonthFilter}
                  onChange={e => setSalaryMonthFilter(e.target.value)}
                  style={{ padding: '6px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '13px', outline: 'none', background: '#fff', fontWeight: 600, color: '#334155', cursor: 'pointer' }}
                >
                  {monthsListOptions.map(m => (
                    <option key={m.value} value={m.value}>{m.label}</option>
                  ))}
                </select>
              </div>
            </div>

            {/* Salary KPI Cards */}
            <div className="oc-grid-overview" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '16px', marginBottom: '20px' }}>
              {localKpis.map((kpi, idx) => (
                <div className="oc-card oc-kpi-card" key={idx}>
                  <div className="oc-kpi-header">
                    <div className="oc-kpi-title">{kpi.title}</div>
                    <div className="oc-kpi-icon" style={{ background: ['#eff6ff', '#f0fdf4', '#f5f3ff', '#fff7ed', '#ecfdf5', '#fef2f2', '#f5f3ff', '#fffbeb'][idx], color: ['#2563eb', '#16a34a', '#8b5cf6', '#ea580c', '#10b981', '#ef4444', '#8b5cf6', '#ea580c'][idx] }}>
                      {kpi.icon || '💰'}
                    </div>
                  </div>
                  <div className="oc-kpi-value">{kpi.value}</div>
                  <div className="oc-trend-text">{kpi.description}</div>
                </div>
              ))}
            </div>

            {/* Charts Row */}
            <div className="oc-grid-analytics" style={{ gridTemplateColumns: '2fr 1fr', gap: '20px', marginBottom: '20px' }}>
              {/* Month-wise Salary Spends (Total Amount) */}
              <div className="oc-card">
                <div className="oc-section-header">Month-wise Salary Spends</div>
                <Chart
                  options={{
                    chart: { type: 'bar', stacked: false, toolbar: { show: false } },
                    plotOptions: { bar: { borderRadius: 4, columnWidth: '45%' } },
                    xaxis: { categories: salaryData.monthlySummary?.map(m => m.monthName) || [] },
                    colors: ['#2563eb'],
                    yaxis: { labels: { formatter: formatChartCurrency } },
                    dataLabels: { enabled: false },
                    legend: { position: 'top' },
                    tooltip: { y: { formatter: formatChartCurrency } }
                  }}
                  series={[
                    { name: 'Total Salary Spends', data: salaryData.monthlySummary?.map(m => m.totalAmount) || [] }
                  ]}
                  type="bar"
                  height={300}
                />
              </div>

              {/* Status-wise Salary Distribution */}
              <div className="oc-card">
                <div className="oc-section-header">Salary by Status</div>
                <Chart
                  options={{
                    chart: { type: 'donut' },
                    labels: statusLabels,
                    colors: ['#3b82f6', '#10b981', '#f59e0b', '#8b5cf6', '#ec4899', '#64748b'],
                    dataLabels: { enabled: false },
                    legend: { position: 'bottom' },
                    tooltip: { y: { formatter: formatChartCurrency } }
                  }}
                  series={statusSeries}
                  type="donut"
                  height={300}
                />
              </div>
            </div>

            {/* Second Row: Site distribution & Tickets Table */}
            <div className="oc-grid-analytics" style={{ gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
              {/* Top 10 Sites by Salary Spends */}
              <div className="oc-card">
                <div className="oc-section-header">Top Sites by Salary Spends</div>
                <Chart
                  options={{
                    chart: { type: 'bar', toolbar: { show: false } },
                    plotOptions: { bar: { borderRadius: 4, barHeight: '55%' } },
                    colors: ['#8b5cf6'],
                    xaxis: {
                      type: 'category',
                      categories: sortedSites.map(s => s.name) || [],
                      labels: {
                        formatter: (val) => val
                      }
                    },
                    yaxis: { labels: { formatter: formatChartCurrency } },
                    dataLabels: { enabled: false },
                    tooltip: { y: { formatter: formatChartCurrency } }
                  }}
                  series={[{ name: 'Salary Spends', data: sortedSites.map(s => s.amount) || [] }]}
                  type="bar"
                  height={350}
                />
              </div>

              {/* Salary Tickets Table */}
              <div className="oc-card" style={{ display: 'flex', flexDirection: 'column' }}>
                <div className="oc-section-header" style={{ marginBottom: '16px' }}>Salary Budget Tickets</div>
                <div style={{ overflowX: 'auto', flexGrow: 1 }}>
                  <table className="oc-table" style={{ width: '100%', fontSize: '13px' }}>
                    <thead>
                      <tr>
                        <th>Ticket No</th>
                        <th>Site Name</th>
                        <th>Month</th>
                        <th style={{ textAlign: 'right' }}>Amount</th>
                        <th style={{ textAlign: 'center' }}>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredTickets.length > 0 ? (
                        filteredTickets.map((t, idx) => (
                          <tr key={idx}>
                            <td style={{ fontWeight: 600, color: '#2563eb', cursor: 'pointer' }}
                              onClick={() => {
                                const url = `${window.location.origin}${RoutesLink.salary_ticket_detail}/${t.id}`;
                                window.open(url, '_blank');
                              }}>{t.ticketNumber}</td>
                            <td>{t.siteName}</td>
                            <td>{t.month}</td>
                            <td style={{ textAlign: 'right', fontWeight: 600 }}>{formatChartCurrency(t.totalAmount)}</td>
                            <td style={{ textAlign: 'center' }}>
                              <span style={{
                                display: 'inline-block',
                                padding: '2px 8px',
                                borderRadius: '12px',
                                fontSize: '11px',
                                fontWeight: 600,
                                textTransform: 'capitalize',
                                backgroundColor: (t.status || '').toLowerCase().includes('approve') ? '#e6f4ea' : (t.status || '').toLowerCase().includes('paid') || (t.status || '').toLowerCase().includes('completed') ? '#e8f0fe' : '#fef3c7',
                                color: (t.status || '').toLowerCase().includes('approve') ? '#137333' : (t.status || '').toLowerCase().includes('paid') || (t.status || '').toLowerCase().includes('completed') ? '#1a73e8' : '#b25e00'
                              }}>
                                {t.status}
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" style={{ textAlign: 'center', color: '#64748b', padding: '30px' }}>
                            No salary tickets found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </>
        );
      })()}

      {/* ZONE 4: Operational Pulse & Alerts */}
      {activeZone === 'pulse' && (
        <div className="oc-grid-analytics" style={{ gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
          <div className="oc-card">
            <div className="oc-section-header" style={{ color: '#dc2626' }}>ERP Operational Risk & Alerts</div>
            <div className="oc-alert-list">
              {alerts.map((alert, i) => (
                <div key={i} className={`oc-alert-item oc-alert-${alert.type}`}>
                  <div className="oc-alert-icon">{alert.icon || '⚠️'}</div>
                  <div className="oc-alert-content">
                    <h4>{alert.title}</h4>
                    <p>{alert.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="oc-card">
            <div className="oc-section-header">Live Operations Feed</div>
            <div className="oc-timeline" style={{ paddingLeft: '16px' }}>
              {activities.length > 0 ? activities.map((act, i) => (
                <div key={i} className="oc-timeline-item" style={{ position: 'relative', paddingLeft: '20px', marginBottom: '16px' }}>
                  <div style={{ position: 'absolute', left: 0, top: '4px', width: '10px', height: '10px', borderRadius: '50%', background: '#2563eb' }}></div>
                  <div style={{ fontSize: '11px', color: '#94a3b8', fontWeight: 600 }}>{act.timestamp || 'Today'}</div>
                  <div style={{ fontSize: '13px', fontWeight: 600, color: '#0f172a' }}>{act.title}</div>
                  <div style={{ fontSize: '12px', color: '#64748b' }}>{act.description}</div>
                </div>
              )) : (
                <div style={{ color: '#64748b', fontSize: '13px', padding: '20px 0' }}>No recent operation events recorded.</div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* GST Summary Side Drawer Overlay */}
      <div className={`oc-drawer-overlay ${gstDrawerOpen ? 'open' : ''}`} onClick={() => setGstDrawerOpen(false)}></div>

      {/* GST Summary Side Drawer Body */}
      <div className={`oc-drawer ${gstDrawerOpen ? 'open' : ''}`} style={{ width: '650px', maxWidth: '95%' }}>
        <div className="oc-drawer-header">
          <div>
            <h2>GST Summary Details</h2>
            <div style={{ fontSize: '13px', color: '#64748b', marginTop: '4px' }}>
              Indicative management view • Not for GSTR filing
            </div>
          </div>
          <button className="oc-drawer-close" onClick={() => setGstDrawerOpen(false)}>&times;</button>
        </div>

        <div className="oc-drawer-content" style={{ padding: '20px' }}>
          {(() => {
            const gstRates = gstSummaryData.rates || [];
            const rate5 = gstRates.find(r => r.rate === '5%') || { output: 0, input: 0, net: 0, formattedOutput: '₹ 0', formattedInput: '₹ 0', formattedNet: '₹ 0' };
            const rate12 = gstRates.find(r => r.rate === '12%') || { output: 0, input: 0, net: 0, formattedOutput: '₹ 0', formattedInput: '₹ 0', formattedNet: '₹ 0' };
            const rate18 = gstRates.find(r => r.rate === '18%') || { output: 0, input: 0, net: 0, formattedOutput: '₹ 0', formattedInput: '₹ 0', formattedNet: '₹ 0' };
            const rate28 = gstRates.find(r => r.rate === '28%') || { output: 0, input: 0, net: 0, formattedOutput: '₹ 0', formattedInput: '₹ 0', formattedNet: '₹ 0' };

            const gstBarChart = {
              series: [
                {
                  name: 'Output',
                  data: [rate5.output, rate12.output, rate18.output, rate28.output]
                },
                {
                  name: 'Input',
                  data: [rate5.input, rate12.input, rate18.input, rate28.input]
                }
              ],
              options: {
                chart: {
                  type: 'bar',
                  height: 280,
                  toolbar: { show: false }
                },
                plotOptions: {
                  bar: {
                    horizontal: false,
                    columnWidth: '45%',
                    endingShape: 'rounded'
                  },
                },
                dataLabels: {
                  enabled: false
                },
                stroke: {
                  show: true,
                  width: 2,
                  colors: ['transparent']
                },
                xaxis: {
                  categories: ['5%', '12%', '18%', '28%'],
                  labels: {
                    style: {
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 500
                    }
                  }
                },
                yaxis: {
                  title: {
                    text: 'Amount (₹)',
                    style: {
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 600
                    }
                  },
                  labels: {
                    formatter: (val) => `₹ ${val.toLocaleString('en-IN')}`
                  }
                },
                fill: {
                  opacity: 1
                },
                colors: ['#10b981', '#1e3a8a'],
                legend: {
                  fontFamily: 'Inter, sans-serif',
                  position: 'top'
                },
                tooltip: {
                  y: {
                    formatter: (val) => `₹ ${val.toLocaleString('en-IN')}`
                  }
                }
              }
            };

            return (
              <>
                {/* GST KPI Cards */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px', marginBottom: '24px' }}>
                  <div className="oc-card" style={{ padding: '14px', background: '#f0fdf4', border: '1px solid #bbf7d0' }}>
                    <div style={{ fontSize: '11px', color: '#166534', fontWeight: 600 }}>Output GST (Sales)</div>
                    <div style={{ fontSize: '18px', fontWeight: 700, color: '#14532d', marginTop: '6px' }}>{gstSummaryData.summary?.formattedOutputGst || '₹ 0'}</div>
                  </div>
                  <div className="oc-card" style={{ padding: '14px', background: '#eff6ff', border: '1px solid #bfdbfe' }}>
                    <div style={{ fontSize: '11px', color: '#1e40af', fontWeight: 600 }}>Input GST (Purchases)</div>
                    <div style={{ fontSize: '18px', fontWeight: 700, color: '#1e3a8a', marginTop: '6px' }}>{gstSummaryData.summary?.formattedInputGst || '₹ 0'}</div>
                  </div>
                  <div className="oc-card" style={{
                    padding: '14px',
                    background: (gstSummaryData.summary?.netLiability || 0) >= 0 ? '#fff5f5' : '#f0fdf4',
                    border: (gstSummaryData.summary?.netLiability || 0) >= 0 ? '1px solid #feb2b2' : '1px solid #bbf7d0'
                  }}>
                    <div style={{ fontSize: '11px', color: (gstSummaryData.summary?.netLiability || 0) >= 0 ? '#9b2c2c' : '#166534', fontWeight: 600 }}>Net Liability</div>
                    <div style={{
                      fontSize: '18px',
                      fontWeight: 700,
                      color: (gstSummaryData.summary?.netLiability || 0) >= 0 ? '#742a2a' : '#14532d',
                      marginTop: '6px'
                    }}>{gstSummaryData.summary?.formattedNetLiability || '₹ 0'}</div>
                  </div>
                </div>

                {/* GST Output vs Input Chart */}
                <div className="oc-card" style={{ marginBottom: '24px', padding: '14px' }}>
                  <div style={{ fontSize: '14px', fontWeight: 700, marginBottom: '12px' }}>Output vs Input GST by Rate</div>
                  <Chart options={gstBarChart.options} series={gstBarChart.series} type="bar" height={260} />
                </div>

                {/* GST Breakdown Table */}
                <div className="oc-card" style={{ padding: '14px' }}>
                  <div style={{ fontSize: '14px', fontWeight: 700, marginBottom: '12px' }}>GST Rate Breakdown</div>
                  <table className="oc-table" style={{ fontSize: '12px' }}>
                    <thead>
                      <tr>
                        <th>Rate Slab</th>
                        <th style={{ textAlign: 'right' }}>Output GST</th>
                        <th style={{ textAlign: 'right' }}>Input GST</th>
                        <th style={{ textAlign: 'right' }}>Net Liability</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[rate5, rate12, rate18, rate28].map((row, idx) => (
                        <tr key={idx}>
                          <td style={{ fontWeight: 700 }}>{row.rate}</td>
                          <td style={{ textAlign: 'right', color: '#10b981', fontWeight: 600 }}>{row.formattedOutput}</td>
                          <td style={{ textAlign: 'right', color: '#2563eb', fontWeight: 600 }}>{row.formattedInput}</td>
                          <td style={{
                            textAlign: 'right',
                            fontWeight: 700,
                            color: row.net >= 0 ? '#ef4444' : '#10b981'
                          }}>
                            {row.formattedNet}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            );
          })()}
        </div>
      </div>

      {/* Site Intelligence Drawer Overlay */}
      <div className={`oc-drawer-overlay ${drawerOpen ? 'open' : ''}`} onClick={closeDrawer}></div>

      {/* Site Intelligence Drawer Body */}
      <div className={`oc-drawer ${drawerOpen ? 'open' : ''}`}>
        <div className="oc-drawer-header">
          <div>
            <h2>{selectedSiteDetails ? selectedSiteDetails.name : 'Site Intelligence'}</h2>
            {siteDrilldownData && (
              <div style={{ fontSize: '13px', color: '#64748b', marginTop: '4px' }}>
                <span style={{ color: '#2563eb', fontWeight: 700 }}>{siteDrilldownData.siteInfo.customerName}</span> ({siteDrilldownData.siteInfo.companyName}) <br />
                {siteDrilldownData.siteInfo.address} • Created {siteDrilldownData.siteInfo.createdAt}
              </div>
            )}
          </div>
          <button className="oc-drawer-close" onClick={closeDrawer}>&times;</button>
        </div>

        <div className="oc-drawer-content">
          {selectedSiteDetails && !siteDrilldownData && (
            <div style={{ textAlign: 'center', padding: '60px', color: '#64748b', fontWeight: 600 }}>Loading Site Intelligence Data...</div>
          )}

          {siteDrilldownData && (
            <div>
              {/* Top Financial Posture Cards */}
              <div className="oc-grid-overview" style={{ gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px', marginBottom: '24px' }}>
                <div className="oc-card" style={{ padding: '14px', background: '#f8fafc' }}>
                  <div className="oc-kpi-title" style={{ fontSize: '11px' }}>Total Budget</div>
                  <div className="oc-kpi-value" style={{ fontSize: '18px' }}>{siteDrilldownData.financials.totalBudget}</div>
                </div>
                <div className="oc-card" style={{ padding: '14px', background: '#fffbeb', border: '1px solid #fde68a' }}>
                  <div className="oc-kpi-title" style={{ fontSize: '11px' }}>Committed (POs)</div>
                  <div className="oc-kpi-value" style={{ fontSize: '18px', color: '#d97706' }}>{siteDrilldownData.financials.committedBudget}</div>
                </div>
                <div className="oc-card" style={{ padding: '14px' }}>
                  <div className="oc-kpi-title" style={{ fontSize: '11px' }}>Actually Paid</div>
                  <div className="oc-kpi-value" style={{ fontSize: '18px' }}>{siteDrilldownData.financials.totalSpent}</div>
                </div>
                <div className="oc-card" style={{ padding: '14px', background: '#f0fdf4', border: '1px solid #bbf7d0' }}>
                  <div className="oc-kpi-title" style={{ fontSize: '11px' }}>True Remaining</div>
                  <div className="oc-kpi-value" style={{ fontSize: '18px', color: '#16a34a' }}>{siteDrilldownData.financials.remainingBudget}</div>
                </div>
              </div>

              {/* Monthly Cashflow Overview Table */}
              <div className="oc-section-header">Monthly Cashflow Run-Rate</div>
              <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '12px', overflow: 'hidden', marginBottom: '24px' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                  <thead style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                    <tr>
                      <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600, color: '#64748b' }}>Category</th>
                      <th style={{ padding: '12px 16px', textAlign: 'right', fontWeight: 600, color: '#64748b' }}>Monthly Commit</th>
                      <th style={{ padding: '12px 16px', textAlign: 'right', fontWeight: 600, color: '#64748b' }}>Payment Out</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style={{ borderBottom: '1px solid #f1f5f9' }}>
                      <td style={{ padding: '12px 16px', fontWeight: 600 }}>Purchase Orders</td>
                      <td style={{ padding: '12px 16px', textAlign: 'right', color: '#d97706', fontWeight: 600 }}>{siteDrilldownData.monthlyFinance?.po.committed}</td>
                      <td style={{ padding: '12px 16px', textAlign: 'right', color: '#16a34a', fontWeight: 600 }}>{siteDrilldownData.monthlyFinance?.po.paymentOut}</td>
                    </tr>
                    <tr style={{ borderBottom: '1px solid #f1f5f9' }}>
                      <td style={{ padding: '12px 16px', fontWeight: 600 }}>Salaries</td>
                      <td style={{ padding: '12px 16px', textAlign: 'right', color: '#d97706', fontWeight: 600 }}>{siteDrilldownData.monthlyFinance?.salary.committed}</td>
                      <td style={{ padding: '12px 16px', textAlign: 'right', color: '#16a34a', fontWeight: 600 }}>{siteDrilldownData.monthlyFinance?.salary.paymentOut}</td>
                    </tr>
                    <tr style={{ borderBottom: '1px solid #f1f5f9' }}>
                      <td style={{ padding: '12px 16px', fontWeight: 600 }}>General Expenses</td>
                      <td style={{ padding: '12px 16px', textAlign: 'right', color: '#d97706', fontWeight: 600 }}>{siteDrilldownData.monthlyFinance?.general.committed}</td>
                      <td style={{ padding: '12px 16px', textAlign: 'right', color: '#16a34a', fontWeight: 600 }}>{siteDrilldownData.monthlyFinance?.general.paymentOut}</td>
                    </tr>
                    <tr style={{ background: '#f8fafc', fontWeight: 700 }}>
                      <td style={{ padding: '12px 16px' }}>Total (This Month)</td>
                      <td style={{ padding: '12px 16px', textAlign: 'right', color: '#d97706' }}>{siteDrilldownData.monthlyFinance?.total.committed}</td>
                      <td style={{ padding: '12px 16px', textAlign: 'right', color: '#16a34a' }}>{siteDrilldownData.monthlyFinance?.total.paymentOut}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Operations Pulse */}
              <div className="oc-section-header">Operations Pulse</div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px', marginBottom: '24px' }}>
                <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '16px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: '#eff6ff', color: '#2563eb', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px' }}>👷</div>
                  <div>
                    <div style={{ fontSize: '18px', fontWeight: 800 }}>{siteDrilldownData.metrics.manpower?.actual || 0} <span style={{ fontSize: '12px', color: '#64748b', fontWeight: 500 }}>/ {siteDrilldownData.metrics.manpower?.planned || 0} planned</span></div>
                    <div style={{ fontSize: '12px', color: '#64748b' }}>Active Manpower</div>
                  </div>
                </div>

                <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '16px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: '#fef2f2', color: '#ef4444', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px' }}>🏗️</div>
                  <div>
                    <div style={{ fontSize: '18px', fontWeight: 800 }}>{siteDrilldownData.metrics.machinery?.total || 0} <span style={{ fontSize: '12px', color: '#ef4444', fontWeight: 500 }}>({siteDrilldownData.metrics.machinery?.idle || 0} Idle)</span></div>
                    <div style={{ fontSize: '12px', color: '#64748b' }}>Machinery & Assets</div>
                  </div>
                </div>
              </div>

              {/* Work Orders Detailed Analysis */}
              <div className="oc-section-header">Work Orders Intelligence</div>

              <div className="oc-grid-overview" style={{ gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px', marginBottom: '16px' }}>
                <div style={{ background: '#f8fafc', padding: '12px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                  <div style={{ fontSize: '11px', color: '#64748b', fontWeight: 600 }}>Active Orders</div>
                  <div style={{ fontSize: '16px', fontWeight: 800, color: '#0f172a', marginTop: '4px' }}>{siteDrilldownData.workOrdersSummary?.totalCount || 0}</div>
                </div>
                <div style={{ background: '#f5f3ff', padding: '12px', borderRadius: '8px', border: '1px solid #ddd6fe' }}>
                  <div style={{ fontSize: '11px', color: '#5b21b6', fontWeight: 600 }}>Total Valued</div>
                  <div style={{ fontSize: '16px', fontWeight: 800, color: '#4c1d95', marginTop: '4px' }}>{siteDrilldownData.workOrdersSummary?.totalValued || '₹ 0'}</div>
                </div>
                <div style={{ background: '#eff6ff', padding: '12px', borderRadius: '8px', border: '1px solid #bfdbfe' }}>
                  <div style={{ fontSize: '11px', color: '#1e40af', fontWeight: 600 }}>Total Invoiced</div>
                  <div style={{ fontSize: '16px', fontWeight: 800, color: '#1e3a8a', marginTop: '4px' }}>{siteDrilldownData.workOrdersSummary?.totalInvoiced || '₹ 0'}</div>
                </div>
                <div style={{ background: '#f0fdf4', padding: '12px', borderRadius: '8px', border: '1px solid #bbf7d0' }}>
                  <div style={{ fontSize: '11px', color: '#166534', fontWeight: 600 }}>Cleared/Paid</div>
                  <div style={{ fontSize: '16px', fontWeight: 800, color: '#14532d', marginTop: '4px' }}>{siteDrilldownData.workOrdersSummary?.totalCleared || '₹ 0'}</div>
                </div>
              </div>

              <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '12px', overflow: 'hidden', marginBottom: '24px' }}>
                {siteDrilldownData.workOrdersSummary?.list && siteDrilldownData.workOrdersSummary.list.length > 0 ? (
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                    <thead style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                      <tr>
                        <th style={{ padding: '8px 12px', textAlign: 'left', color: '#64748b' }}>Order Info</th>
                        <th style={{ padding: '8px 12px', textAlign: 'right', color: '#64748b' }}>Total Valued</th>
                        <th style={{ padding: '8px 12px', textAlign: 'right', color: '#64748b' }}>Invoiced</th>
                        <th style={{ padding: '8px 12px', textAlign: 'right', color: '#64748b' }}>Cleared (Paid)</th>
                        <th style={{ padding: '8px 12px', textAlign: 'center', color: '#64748b' }}>Billed %</th>
                      </tr>
                    </thead>
                    <tbody>
                      {siteDrilldownData.workOrdersSummary.list.map((wo, idx) => (
                        <tr
                          key={idx}
                          onClick={() => window.open(`${window.location.origin}${RoutesLink.work_order_detail}/${wo.id}`, '_blank')}
                          style={{ borderBottom: '1px solid #f1f5f9', cursor: 'pointer' }}
                          className="oc-table-row-hover"
                        >
                          <td style={{ padding: '8px 12px' }}>
                            <div style={{ fontWeight: 700, color: '#0f172a' }}>{wo.workOrderNumber}</div>
                            <div style={{ fontSize: '10px', color: '#64748b' }}>{wo.title}</div>
                          </td>
                          <td style={{ padding: '8px 12px', textAlign: 'right', fontWeight: 600 }}>{wo.totalAmount}</td>
                          <td style={{ padding: '8px 12px', textAlign: 'right', fontWeight: 600, color: '#2563eb' }}>{wo.invoicedAmount}</td>
                          <td style={{ padding: '8px 12px', textAlign: 'right', fontWeight: 600, color: '#16a34a' }}>{wo.clearedAmount}</td>
                          <td style={{ padding: '8px 12px', textAlign: 'center' }}>
                            <span style={{
                              background: '#eff6ff',
                              color: '#2563eb',
                              padding: '2px 6px',
                              borderRadius: '4px',
                              fontWeight: 700,
                              fontSize: '10px'
                            }}>
                              {wo.progressPercent}%
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div style={{ textAlign: 'center', color: '#64748b', padding: '24px', fontSize: '12px' }}>No work orders found for this site.</div>
                )}
              </div>

              {/* Recent Site Expenses */}
              <div className="oc-section-header">Recent Payment Expenses</div>
              <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '12px', overflow: 'hidden', marginBottom: '24px' }}>
                {siteRecentExpenses.length > 0 ? (
                  <table className="oc-table">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Vendor</th>
                        <th>Amount</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {siteRecentExpenses.slice(0, 5).map((exp, idx) => (
                        <tr key={idx} onClick={() => openPaymentTicketDetail(exp)} style={{ cursor: 'pointer' }} className="oc-table-row-hover">
                          <td>{exp.date}</td>
                          <td style={{ fontWeight: 600 }}>{exp.vendor}</td>
                          <td style={{ fontWeight: 700 }}>{exp.amount}</td>
                          <td><span className={`oc-status-badge oc-status-${exp.status ? exp.status.toLowerCase() : 'pending'}`}>{exp.status}</span></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div style={{ textAlign: 'center', color: '#64748b', padding: '24px' }}>No recent expenses found for this site.</div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Vendor Intelligence Drawer Overlay */}
      <div className={`oc-drawer-overlay ${vendorDrawerOpen ? 'open' : ''}`} onClick={() => setVendorDrawerOpen(false)}></div>

      {/* Vendor Intelligence Drawer Body */}
      <div className={`oc-drawer ${vendorDrawerOpen ? 'open' : ''}`}>
        <div className="oc-drawer-header">
          <div>
            <h2>{selectedVendorDetails ? selectedVendorDetails.firmName : 'Vendor Intelligence'}</h2>
            <div style={{ fontSize: '12px', color: '#64748b', marginTop: '4px' }}>
              👤 Owner: {selectedVendorDetails?.name} • Code: {selectedVendorDetails?.vendorNumber || '--'}
            </div>
          </div>
          <button className="oc-drawer-close" onClick={() => setVendorDrawerOpen(false)}>&times;</button>
        </div>

        <div className="oc-drawer-content">
          {selectedVendorDetails && (
            <div>
              {/* Summary Cards */}
              <div className="oc-grid-overview" style={{ gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px', marginBottom: '24px' }}>
                <div className="oc-card" style={{ padding: '14px', background: '#f8fafc' }}>
                  <div className="oc-kpi-title" style={{ fontSize: '11px' }}>POs Allocated</div>
                  <div className="oc-kpi-value" style={{ fontSize: '18px' }}>{selectedVendorDetails.poTotal}</div>
                  <div className="oc-trend-text" style={{ fontSize: '10px' }}>{selectedVendorDetails.poCount} Orders</div>
                </div>
                <div className="oc-card" style={{ padding: '14px', background: '#f0fdf4', border: '1px solid #bbf7d0' }}>
                  <div className="oc-kpi-title" style={{ fontSize: '11px' }}>Total Disbursed</div>
                  <div className="oc-kpi-value" style={{ fontSize: '18px', color: '#16a34a' }}>{selectedVendorDetails.totalPaid}</div>
                </div>
                <div className="oc-card" style={{ padding: '14px', background: '#fffbeb', border: '1px solid #fde68a' }}>
                  <div className="oc-kpi-title" style={{ fontSize: '11px' }}>Pending Clearance</div>
                  <div className="oc-kpi-value" style={{ fontSize: '18px', color: '#d97706' }}>{selectedVendorDetails.pendingAmount}</div>
                </div>
              </div>

              {/* Contact & Banking Grid */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '24px' }}>
                {/* Firm Profile */}
                <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '16px' }}>
                  <h4 style={{ margin: '0 0 12px 0', fontSize: '13px', color: '#0f172a', fontWeight: 700 }}>📞 Firm Profile</h4>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '12px' }}>
                    <div><span style={{ color: '#64748b' }}>Phone:</span> {selectedVendorDetails.phone}</div>
                    <div><span style={{ color: '#64748b' }}>Email:</span> {selectedVendorDetails.email}</div>
                    <div><span style={{ color: '#64748b' }}>Location:</span> {selectedVendorDetails.city}, {selectedVendorDetails.state}</div>
                    <div><span style={{ color: '#64748b' }}>Address:</span> {selectedVendorDetails.address}</div>
                  </div>
                </div>

                {/* Bank Account Details */}
                <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '16px' }}>
                  <h4 style={{ margin: '0 0 12px 0', fontSize: '13px', color: '#0f172a', fontWeight: 700 }}>🏦 Bank Verification</h4>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '12px' }}>
                    <div><span style={{ color: '#64748b' }}>Bank:</span> {selectedVendorDetails.bankName}</div>
                    <div><span style={{ color: '#64748b' }}>Holder:</span> {selectedVendorDetails.accountHolderName}</div>
                    <div><span style={{ color: '#64748b' }}>Account No:</span> {selectedVendorDetails.accountNumber}</div>
                    <div><span style={{ color: '#64748b' }}>IFSC Code:</span> {selectedVendorDetails.ifscCode}</div>
                  </div>
                </div>
              </div>

              {/* Taxation & Registration */}
              <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '16px', marginBottom: '24px' }}>
                <h4 style={{ margin: '0 0 12px 0', fontSize: '13px', color: '#0f172a', fontWeight: 700 }}>📄 Statutory & Tax Identifiers</h4>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', fontSize: '12px' }}>
                  <div><span style={{ color: '#64748b' }}>GSTIN:</span> <strong style={{ color: '#0f172a' }}>{selectedVendorDetails.gstNumber}</strong></div>
                  <div><span style={{ color: '#64748b' }}>PAN:</span> <strong style={{ color: '#0f172a' }}>{selectedVendorDetails.panNumber}</strong></div>
                </div>
              </div>

              {/* Recent Purchase Orders */}
              <div className="oc-section-header">Recent Purchase Orders</div>
              <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '12px', overflow: 'hidden', marginBottom: '24px' }}>
                {selectedVendorDetails.pos && selectedVendorDetails.pos.length > 0 ? (
                  <table className="oc-table" style={{ fontSize: '12px' }}>
                    <thead>
                      <tr>
                        <th>PO Number</th>
                        <th>Date</th>
                        <th>Total</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedVendorDetails.pos.map((po, idx) => (
                        <tr key={idx}>
                          <td style={{ fontWeight: 600, color: '#2563eb' }}>{po.purchaseNumber}</td>
                          <td>{po.date}</td>
                          <td style={{ fontWeight: 600 }}>{po.totalAmount}</td>
                          <td><span className="oc-status-badge oc-status-approved">{po.status}</span></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div style={{ textAlign: 'center', color: '#64748b', padding: '16px', fontSize: '12px' }}>No purchase orders issued for this vendor.</div>
                )}
              </div>

              {/* Recent Payment Tickets */}
              <div className="oc-section-header">Recent Payment Clearance Ledger</div>
              <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '12px', overflow: 'hidden', marginBottom: '24px' }}>
                {selectedVendorDetails.tickets && selectedVendorDetails.tickets.length > 0 ? (
                  <table className="oc-table" style={{ fontSize: '12px' }}>
                    <thead>
                      <tr>
                        <th>Ticket No</th>
                        <th>Date</th>
                        <th>Amount</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedVendorDetails.tickets.map((t, idx) => (
                        <tr key={idx} onClick={() => openPaymentTicketDetail(t)} style={{ cursor: 'pointer' }} className="oc-table-row-hover">
                          <td style={{ fontWeight: 600, color: '#2563eb' }}>{t.ticketNo}</td>
                          <td>{t.date}</td>
                          <td style={{ fontWeight: 600 }}>{t.amount}</td>
                          <td><span className={`oc-status-badge oc-status-${t.status?.toLowerCase()}`}>{t.status}</span></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div style={{ textAlign: 'center', color: '#64748b', padding: '16px', fontSize: '12px' }}>No payment clearances recorded.</div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OperationsCenter;
